/*!
 * Helper functions for form library
 * Copyright 2018, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

// [Obsolete]
function getQueryStringParameterByName(name) {
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search);
	return results == null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// ---------------------------------------------------------
// Data table helper functions
// ---------------------------------------------------------
function getDataTableById(id) {
	var retVal = null;
	var el = document.getElementById(id);
	if ($.fn.DataTable.isDataTable(el)) retVal = $('#' + id).dataTable();
	return retVal;
}

function GetSelerixDataTableState(datatable) {

	if (!$.fn.DataTable.isDataTable(datatable))
		return "";

	var settings = getDataTableById($(datatable).get(0).id).fnSettings();
	var aSortSetting = [];
	for (var sortCol in settings.aLastSort) {
		var item = settings.aLastSort[sortCol];
		aSortSetting.push(
			{
				columnID: item.col,
				direction: item.dir
			});
	}

	var selectedStates = {
		sorting: aSortSetting,
		displayStart: settings._iDisplayStart
	}
	return JSON.stringify(selectedStates);
}

function makeSelerixDataTable(t) {
	if ($.fn.DataTable.isDataTable(t)) return;
	var table = $(t);

	var aoColumns = [];
	var aaSorting = [];
	var unsortSorting = [];

	var responsive = table.attr('data-responsive') == 'true';
	if (responsive) {
		// automatically add expander column as hidden until needed
		if (!table.find("th.control, td.control").length) {
			// add expander header column
			if (!table.find("th.control").length) {
				table.find("thead > tr").prepend($('<TH/>').addClass('control controls').attr({ 'data-bSortable': 'false', 'data-bSearchable': 'false' }));
			}
			// add expander data column for tables using repeater
			if (!table.data("sajaxsource")) {
				if (!table.find("td.control").length) {
					var tr = table.find("tbody > tr, tfoot > tr");
					if (tr.length) tr.prepend($("<TD/>").addClass("control controls"));
				}
			}
		}
	}

	var idx = 0;
	table.find('thead tr:last-child th').each(function () {
		// add control column for ajax datatables
		if (responsive && idx == 0 && table.data("sajaxsource")) {
			aoColumns.push({
				'bSortable': 'false',
				'bSearchable': 'false',
				'bVisible': 'true',
				'sClass': 'control controls'
			});
			idx++;
			return;
		}
		// standard data columns
		var sClass = $(this).attr('data-sClass');
		var bSortable = !$(this).attr('data-bSortable') || $(this).attr('data-bSortable').toLowerCase() == 'true';
		var bSearchable = !$(this).attr('data-bSearchable') || $(this).attr('data-bSearchable').toLowerCase() == 'true';
		var bVisible = !$(this).attr('data-bVisible') || $(this).attr('data-bVisible').toLowerCase() == 'true';
		var sName = $(this).attr('data-sName');
		var sType = $(this).attr('data-sType');
		var orderNum = $(this).attr('data-orderNum');
		var orderDirection = $(this).attr('data-orderDirection');
		var styles = $(this).attr('data-style');
		var mRender = $(this)[0].mRender;

		aoColumns.push({
			'sName': sName,
			'bSortable': bSortable,
			'bSearchable': bSearchable,
			'bVisible': bVisible,
			'sClass': sClass,
			'sType': sType,
			'mRender': mRender,
			'style': styles
		});

		if (orderDirection) unsortSorting.push({ 'order': orderNum ? parseInt(orderNum) : idx, 'index': idx, 'direction': orderDirection });
		idx++;
	});

	unsortSorting = unsortSorting.sort(function (a, b) { return a.order - b.order; });

	for (var i = 0; i < unsortSorting.length; i++) {
		aaSorting.push([unsortSorting[i].index, unsortSorting[i].direction]);
	}

	var rowsPerPage = parseInt(table.attr('data-rowsperpage')) || 10;
	var displayStart = parseInt(table.attr('data-displayStart')) || 0;

	var displayItem = parseInt(table.attr('data-displayItem'));
	if (isNaN(displayItem) || displayItem < 0)
		displayItem = -1;

	var sDom = table.attr('data-sDom');
	var ajaxUrl = table.attr('data-sAjaxSource');
	var sServerMethod = table.attr('data-sServerMethod') || '';
	var webMethod = sServerMethod.toLowerCase() == 'webmethod';

	var fnServerParams = table[0].fnServerParams;
	var drawCallback = table[0].drawCallback;
	var fnInitComplete = table[0].fnInitComplete;
	var fnRowCallback = table[0].fnRowCallback;
	var fnHeaderCallback = table[0].fnHeaderCallback;
	var fnServerData = table[0].fnServerData;

	if (responsive) {
		// on server just check request["responsive"] and request["autoControlColumn"]
		var oldFnServerParams = fnServerParams;
		fnServerParams = (function (aoData) {
			aoData.push({ 'name': 'responsive', 'value': true });
			if (oldFnServerParams) oldFnServerParams(aoData);
		});
	}

	if (webMethod) {
		sServerMethod = 'POST';
		if (fnServerData === null || typeof fnServerData === 'undefined') fnServerData = DataTable_WebMethod_fnServerData;
	} else if (ajaxUrl && (fnServerData === null || typeof fnServerData === 'undefined')) {
		fnServerData = DataTable_Ajax_fnServerData;
	}

	var bProcessing = !table.attr('data-bProcessing') || table.attr('data-bProcessing') == 'true';
	var bLengthChange = !table.attr('data-bLengthChange') || table.attr('data-bLengthChange') == 'true';
	var bFilter = !table.attr('data-bFilter') || table.attr('data-bFilter') == 'true';
	var bAutoWidth = false; //!table.attr('data-bAutoWidth') || table.attr('data-bAutoWidth') == 'true';
	var oSearch = table.attr('data-oSearch') || '';
	var paging = !table.attr('data-paging') || table.attr('data-paging') == 'true';
	var ordering = !table.attr('data-ordering') || table.attr('data-ordering') == 'true';

	var dTable = {};
	dTable.dom = sDom ? sDom : '<"dataTable_top"lf>rt<"dataTable_bottom"ip><"clear">';
	dTable.ordering = ordering;
	dTable.pagingType = "full_numbers";
	dTable.paging = paging;
	dTable.pageLength = rowsPerPage;
	dTable.displayStart = displayStart;
	dTable.lengthChange = bLengthChange;
	dTable.searching = bFilter;
	dTable.autoWidth = bAutoWidth;
	dTable.serverSide = ajaxUrl ? true : false;
	dTable.bProcessing = bProcessing;
	dTable.ajaxSource = ajaxUrl;
	dTable.serverMethod = sServerMethod ? sServerMethod : "GET";
	dTable.fnServerParams = fnServerParams;
	dTable.deferRender = table.attr('data-deferRender') == 'true';
	if (dTable.searching) table.addClass('dataTable_filterPlaceholder');

	dTable.drawCallback = function (settings) {
		var id = "#" + $(this)[0].id + "_paginate";
		if ($(id + " span .paginate_button").length <= 1) {
			$("#" + $(this)[0].id + "_info").hide();
			$(id).hide();

		} else {
			$("#" + $(this)[0].id + "_info").show();
			$(id).show();
		}
		if (typeof (drawCallback) == "function") drawCallback(settings);

		if (displayItem >= 0 && paging) {
			var rowMap = this.DataTable().settings()[0].aiDisplay;
			var pgLng = settings._iDisplayLength;
			for (var i in rowMap) {
				if (rowMap[i] == displayItem) {
					if (pgLng > 0) {
						var pageNum = Math.floor(i / pgLng);
						this._fnPageChange(pageNum, true);
					}
					break;
				}
			}
			displayItem = -1;
		}
		$('[data-toggle="tooltip"]:not([data-original-title])').tooltip();
	};

	var keyDelay = ajaxUrl ? 750 : 0;
	table[0].searchDelay = keyDelay;
	dTable.fnInitComplete = function () {
		// http://datatables.net/forums/discussion/2708/fnsetfilteringdelay-does-not-work-for-me-when-i-use-olanguage-to-initialize-the-datatables
		if (typeof (fnInitComplete) == "function") fnInitComplete();
		focusPageElement();
	};
	dTable.fnServerData = fnServerData;

	dTable.fnHeaderCallback = function (nHead, aData, iStart, iEnd, aiDisplay) {
		$(nHead).find('th').each(function () {
			if (!$(this).find('span:not([class]), span.block')[0]) $(this).wrapInner("<span></span>");
		});
		if (typeof (fnHeaderCallback) == "function") fnHeaderCallback(nHead, aData, iStart, iEnd, aiDisplay);
	}

	dTable.fnRowCallback = function (row, data, displayIndex, displayIndexFull) {
		var cols = this.DataTable().settings()[0].aoColumns;
		for (var i = 0; i < cols.length; i++) {
			if (cols[i].style) $($(row).children()[i]).attr("style", cols[i].style);
		}
		if (typeof (fnRowCallback) == "function") fnRowCallback(row, data, displayIndex, displayIndexFull);
	}

	dTable.aaSorting = aaSorting;
	dTable.responsive = responsive;
	if (responsive) {
		if (table.find("thead th.control, thead td.control").length) {
			dTable.responsive = { details: { type: 'column' } };
		}
	}
	dTable.aoColumns = aoColumns;

	var url = selerix.applicationRoot + 'App_SelerixResource/Selerix.Forms.dll/Selerix.Forms.Web.WebHandlers.DataTablesLocalizationHandler.aspx';
	var sTextBankNameSpace = table.attr('data-textBankNameSpace');
	if (sTextBankNameSpace) url += '?namespace=' + escape(sTextBankNameSpace);

	dTable.language = { "url": url };
	dTable.language.processing = '<span class="glyphicons glyphicons-refresh spinning"></span>';

	if (table[0].fnServerData) dTable.fnServerData = table[0].fnServerData;
	dTable.search = { "search": oSearch };

	var iDeferLoading = parseInt(table.attr('data-iDeferLoading'));
	if (iDeferLoading) dTable.iDeferLoading = iDeferLoading;
	var api = table.dataTable(dTable).api();

	api.on('draw.dtr', function (event, datatable, columns) {
		var resp = $('#' + $(this)[0].id).closest('.table-responsive');
		if (resp.length > 0) recalcTableResponsive(resp[0]);
	});

	// inject blank data column into json for expander column
	if (responsive && table.data("sajaxsource")) {
		table.dataTable().on('xhr.dt', function (e, settings, json) {
			if (json.aaData) {
				for (var i = 0, ien = json.aaData.length; i < ien; i++) json.aaData[i].unshift("");
			}
			return json;
		});
	}
}

/**
 * Server Data override for server-side DataTables.
 * @param {any} sSource AJAX URL.
 * @param {any} aoData Service parameters.
 * @param {any} fnCallback Search callback.
 * @param {any} oSettings DataTable settings.
 */
function DataTable_Ajax_fnServerData(sSource, aoData, fnCallback, oSettings) {
	var el = oSettings.nTable;

	// clear existing timer
	if (el.timer !== undefined) {
		clearTimeout(el.timer);
		delete el.timer;
	}

	// set new search timer
	el.timer = setTimeout(function fnServerDataAjax() {
		// do ajax call
		oSettings.jqXHR = $.ajax({
			url: sSource,
			data: aoData,
			success: fnCallback,
			dataType: 'json',
			cache: false,
			type: oSettings.sServerMethod
		});

		// clear timer on search
		clearTimeout(el.timer);
		delete el.timer;
	}, el.searchDelay || 0);
}

function DataTable_WebMethod_fnServerData(sSource, aoData, fnCallback, oSettings) {
	var data = {};

	data.aoData = aoData;
	$.ajax({
		"url": sSource,
		"type": "POST",
		"data": JSON.stringify(data),
		"contentType": "application/json; charset=utf-8",
		"dataType": 'json',
		"success": function (response) {
			var json = JSON.parse(response['d']);
			fnCallback(json);
		}
	});
}

// ---------------------------------------------------------
// Slideshow Navigation
// ---------------------------------------------------------
function paginate(idx, slide) {
	return '<li><a href="" title="">#</a></li>';
}

var RequestHandlerSet = false;
function BeginRequestHandler(sender, args) {

	if (Page_BusyBox) {
		Page_BusyBox.Show(Page_BusyBoxDelayForAjax);
	}

	selerix.globals.focusedElementSelector = document.activeElement ? '#' + document.activeElement.id :
		selerix.globals.focusedElementSelector ? selerix.globals.focusedElementSelector : '';

	if (typeof (Page_ValidationErrors) != "undefined") window.Page_ValidationErrors = new Array;
	selerix.globals.postBackStarted = true;
}

function EndRequestHandler(sender, args) {
	if (Page_BusyBox) Page_BusyBox.Hide();
	focusPageElement();

	$('*[data-show="true"]').each(function () {
		$(this).removeAttr('data-show');
		$(this).modal('show');
	});
}

function focusPageElement() {
	if (selerix.globals.focusedElementSelector && selerix.globals.focusedElementSelector !== '#') $(selerix.globals.focusedElementSelector).focus();
	else $(window).scrollTop(0);
}

/**
 * @typedef {(
 * 'smartSecureMaskInput'
 * |'smartMaskEditor'
 * |'smartTimeEditor'
 * |'smartDateEditor'
 * |'smartDatePicker'
 * |'smartCurrencyEditor'
 * |'smartPercentEditor'
 * |'smartNumericEditor'
 * |'smartTextEditor'
 * |'smartPasswordEditor'
 * |'smartMultilineEditor'
 * |'smartAutoComplete'
 * )} CreateEditorClassName
*/

/**
 * 
 * @param {JQuery} el
 * @param {CreateEditorClassName} className
 * @returns 
 */
function CreateEditor(el, className) {
	if (!(el instanceof jQuery) || el.data('initialized') === true) return;
	if (!el.hasClass('form-control')) el.addClass('form-control');

	var htmlElement = el[0];

	htmlElement.get_value = (function (el) {
		switch (className) {
			case 'smartSecureMaskInput':
			case 'smartMaskEditor':
				return function () { return $('#' + el.data('controlvalueid')).val(); };

			case 'smartTimeEditor':
				return function () { return el.jqxDateTimeInput('val', 'date'); };

			case 'smartDateEditor':
			case 'smartDatePicker':
				return function () { return el.val(); };

			case 'smartCurrencyEditor':
			case 'smartPercentEditor':
			case 'smartNumericEditor':
				return function () { return el.slxNumericInput('numberValue'); };

			case 'smartTextEditor':
				return function () { return el.val(); };

			case 'smartPasswordEditor':
				return function () { return el.jqxPasswordInput('val'); };

			case 'smartMultilineEditor':
				return function () { return el.val(); };

			case 'smartAutoComplete':
				return function () { return el.jqxComboBox('val'); };

			default: return function () { return null; };
		}
	}(el));

	htmlElement.get_text = (function (el) {
		switch (className) {
			case 'smartSecureMaskInput':
			case 'smartMaskEditor':
				return function () { return $('#' + el.data('controltextid')).val(); };

			case 'smartDateEditor':
			case 'smartDatePicker':
				return function () { return el.val(); };

			default: return function () { return null; };
		}
	}(el));

	htmlElement.set_value = function (value, mask) {
		if (value === void 0) return;
		switch (className) {
			case 'smartSecureMaskInput':
			case 'smartMaskEditor':
				var inputMask = (className == "smartSecureMaskInput" ? el.data('editmodemask') : el.data('inputmask')).toString();
				var maskChars = ['a', 'l', 'c', '0', '9', '?', '#', '&', '<', '>', '*'];
				var valueWithMask = null;

				if (value) {
					// remove literals
					var valueOnly = '';
					var j = 0, i;
					for (i = 0; i < inputMask.length; i++) {
						if ($.inArray(inputMask.charAt(i).toLowerCase(), maskChars) == -1) {
							// this is a literal character check value to see if it is also the same character
							if (inputMask.charAt(i) == value.charAt(i)) {
								// the value also contains this literal, skip it
								j++;
							}
							else {
								// the value does not contain this literal, add character from value
								if (j < value.length) valueOnly += value.charAt(j++);
								else break;
							}
						}
						else {
							// this is a mask character add our next value character
							if (j < value.length) valueOnly += value.charAt(j++);
							else break;
						}
					}

					// add mask to value
					valueWithMask = '';
					j = 0;
					for (i = 0; i < inputMask.length; i++) {
						if ($.inArray(inputMask.charAt(i).toLowerCase(), maskChars) == -1) {
							// this is a literal, add literal character from the mask
							valueWithMask += inputMask.charAt(i);
						}
						else {
							// this is a mask character, add character from our valueOnly
							if (j < valueOnly.length) valueWithMask += valueOnly.charAt(j++);
							else break;
						}
					}
				}

				// update ui control
				htmlElement.set_option({ mask: inputMask });
				var kmtb = el.data('kendoMaskedTextBox');
				kmtb.value(valueWithMask);

				value = kmtb.raw().replace(/_/g, '');
				var text = kmtb.value().replace(/_/g, '');

				$("#" + el.data('controlvalueid')).val(value);
				if (value.length) {
					$("#" + el.data('controltextid')).val(text);
				}

				var editMask = (mask ? mask : className == "smartSecureMaskInput" && el.editMode ? el.data('editmodemask') : el.data('inputmask')).toString();

				if (editMask != inputMask) {
					el.data('skipUpdate', true);
					htmlElement.set_option({ mask: editMask.replace(/\*/g, 'C') });
					var valueWitSecurity = '';
					if (valueWithMask != null) {
						for (var i = 0; i < editMask.length; i++) {
							if (editMask[i] == '*')
								valueWitSecurity += '*';
							else
								valueWitSecurity += valueWithMask.charAt(i);
						}
					}
					el.data('kendoMaskedTextBox').value(valueWitSecurity);
					el.data('skipUpdate', false);
				}
				break;
			case 'smartTimeEditor':
				el.jqxDateTimeInput('val', value);
				break;
			case 'smartDateEditor':
			case 'smartDatePicker':
				if (value instanceof Date) {
					el.slxDateSelector('dateValue', value);
				}
				else {
					el.val(ZeroPadDateString(value));
				}

				el.fireChangeEvent();
				break;
			case 'smartCurrencyEditor':
			case 'smartNumericEditor':
			case 'smartPercentEditor':
				el.val(value);
				break;
			case 'smartPasswordEditor':
				el.jqxPasswordInput('val', value);
				break;
			case 'smartTextEditor':
			case 'smartMultilineEditor':
				el.val(value);
				break;
			case 'smartAutoComplete':
				el.jqxComboBox('val', value);
				break;
		}
	}

	htmlElement.set_option = function (options) {
		switch (className) {
			case 'smartSecureMaskInput':
			case 'smartMaskEditor':
				el.data('kendoMaskedTextBox').setOptions(options);
				break;
			case 'smartTimeEditor':
				el.jqxDateTimeInput(options);
				break;
			case 'smartDateEditor':
			case 'smartDatePicker':

				if (options.min) {
					el.data('minvalue', options.min);
					delete options.min;
				}
				if (options.max) {
					el.data('maxvalue', options.max);
					delete options.max;
				}
				el.slxDateSelector(options);
				break;
			case 'smartCurrencyEditor':
			case 'smartPercentEditor':
			case 'smartNumericEditor':
				el.slxNumericInput(options);
				break;
			case 'smartPasswordEditor':
				el.jqxPasswordInput(options);
				break;
			case 'smartAutoComplete':
				el.jqxComboBox(options);
				break;
		}
	}

	var array = {};

	// Global options
	if (el.prop('readOnly')) array.disabled = el.prop('readOnly');
	if (el.prop('disabled')) array.disabled = el.prop('disabled');
	if (el.data('width')) array.width = el.data('width');
	if (el.data('focusonload')) {
		selerix.globals.focusedElementSelector = '#' + el.attr('id');
	}

	// Create the editor
	switch (className) {
		case 'smartPasswordEditor':
			el.jqxPasswordInput(array);
			break;

		case 'smartAutoComplete':

			el.find('option').each(function () {
				var curText = $(this).html();

				curText = curText.replace('<', '&lsaquo;');
				curText = curText.replace('&lt;', '&lsaquo;');

				curText = curText.replace('>', '&rsaquo;');
				curText = curText.replace('&gt;', '&rsaquo;');

				$(this).html(curText);
			});

			var source = {
				datatype: 'json',
				datafields: [
					{ name: 'value' },
					{ name: 'label' },
					{ name: 'searchLabel' }
				],
				url: el.data('searchproviderpath') || '',
				async: false
			};

			array.searchMode = 'containsignorecase';
			array.minLength = 1;
			array.dropDownHeight = 400;
			array.dropDownWidth = el.width();
			array.width = array.width || el.width();
			array.itemHeight = 31;

			var isRemote = el.data('searchproviderpath') !== void 0;
			var settings = {};
			if (isRemote) {
				settings.formatData = function (data) {
					data.term = el.jqxComboBox('searchString');
					return data;
				};
				settings.loadComplete = function (data) {
					el.jqxComboBox('autoDropDownHeight', true);
					if ($('#' + el.attr('aria-owns')).height() - 4 > el.jqxComboBox('dropDownHeight')) el.jqxComboBox('autoDropDownHeight', false);
				};
			}

			var adapter = new $.jqx.dataAdapter(source, settings);
			array.source = adapter;
			array.autoComplete = true;

			if (isRemote) {
				array.remoteAutoComplete = true;
				array.remoteAutoCompleteDelay = 500;
				array.search = function (searchString) {
					if (typeof (searchString) !== 'string') searchString = '%';
					el.jqxComboBox('searchString', searchString);
					adapter.dataBind();
					el.data('isopened', true);
				};
			}

			el.caseSelect = false;
			if (el.closest('form').hasClass('navbar-right')) {
				el.caseSelect = true;
				array.dropDownHorizontalAlignment = 'right';
				array.width = array.width || 300;
				array.dropDownWidth = array.width;
			}

			var parent = el.parent();
			var isDataTable = (parent.closest("table.dataTable").length);
			if (!isDataTable && !parent.hasClass("ui-front")) parent.addClass("ui-front");

			el.jqxComboBox(array);
			var val = $('#' + el.data('selectedvalueid')).val();
			if (isRemote) {
				el.jqxComboBox('addItem', { value: val, label: el.attr('value') });
				el.jqxComboBox('selectIndex', 0);
				el.find('input[type="hidden"]').remove(); // this hidden field was submitting multiple values
			}
			break;

		case 'smartNumericEditor':
		case 'smartPercentEditor':
		case 'smartCurrencyEditor':
			array.type = 'integer';
			if (className === 'smartPercentEditor') {
				array.type = 'percent';
				array.suffix = '%';
			} else if (className === 'smartCurrencyEditor') {
				array.type = 'money';
				array.prefix = '$';
			}
			el.attr('data-type', array.type);

			// backwards compatibility for decimal places
			array.decimalPlaces = el.data('decimalplaces');
			if (array.decimalPlaces !== void 0) {
				el.attr('data-decimal-places', array.decimalPlaces);
				el.removeAttr('data-decimalplaces');
			} else {
				array.decimalPlaces = el.data('decimal-places');
			}

			// backwards compatibility for min value
			array.min = el.data('minvalue');
			if (array.min !== void 0) {
				el.attr('data-min', array.min);
				el.removeAttr('data-minvalue');
			} else {
				array.min = el.data('min');
			}

			// backwards compatibility for max value
			array.max = el.data('maxvalue');
			if (array.max !== void 0) {
				el.attr('data-max', array.max);
				el.removeAttr('data-maxvalue');
			} else {
				array.max = el.data('max');
			}

			var v = el.val();
			array.allowNull = el.data('allownull') === false ? false : true;

			// backwards compatibility for default value
			array.defaultValue = el.data('defaultvalue');
			if (array.defaultValue !== void 0) {
				el.attr('data-default-value', array.defaultValue);
				el.removeAttr('data-defaultvalue');
			} else {
				array.defaultValue = el.data('default-value');
			}

			if (v === '' || isNaN(v)) v = array.defaultValue || null;
			if (v === null && !array.allowNull) v = array.defaultValue || 0;
			if (v < array.min || v > array.max) v = array.min;
			el.slxVal(v);

			el.slxNumericInput();
			el.valChanged = false;
			break;

		case 'smartTimeEditor':
			{
				array.value = null;
				array.width = array.width || 123;

				array.allowNullDate = el.data('nullable') === false ? false : true;

				array.formatString = el.data('datedisplayformat') || 'T';
				array.min = el.data('minvalue') || null;
				array.max = el.data('maxvalue') || null;

				array.showTimeButton = true;
				array.showCalendarButton = false;

				var defaultValue = el.data('defaultvalue') || null;
				var currentValue = el.attr('value') || null;
				htmlElement.set_option(array);

				if (currentValue) htmlElement.set_value(currentValue);
				else if (defaultValue) htmlElement.set_value(defaultValue);

				break;
			}

		case 'smartDateEditor':
		case 'smartDatePicker':
			el.wrap($('<DIV/>').addClass('date-picker'));
			el.fireChangeEvent = function () {
				if (el.data('valuechanged')) {
					Function.evaluate(el.data('valuechanged') + '(params[0], params[1]);', el, htmlElement.get_value());
				}
			}

			htmlElement.checkDate = function () {
				var nullable = el.data('nullable') === false ? false : true;
				var curValue = htmlElement.get_value();

				if (!nullable && curValue == null) {
					var newVal = el.data('defaultvalue') ? el.data('defaultvalue') : (new Date()).toString(el.data('datedisplayformat'));
					htmlElement.set_value(newVal);
					curValue = newVal;
				}

				var minValue = new Date(el.data('minvalue'));
				var maxValue = new Date(el.data('maxvalue'));
				var slx = el.slxControl(); // slxDateSelector
				var curValue = curValue ? slx.dateValue() : '';

				if (minValue && curValue && curValue < minValue) curValue = slx.toDateString(minValue.toString('MM/dd/yyyy'));
				if (maxValue && curValue && curValue > maxValue) curValue = slx.toDateString(maxValue.toString('MM/dd/yyyy'));

				htmlElement.set_value(curValue);
			}

			el.slxDateSelector();
			if (el.data('size')) {
				el.closest('.input-group').addClass('input-group-' + el.data('size'));
			}
			el.valChanged = false;
			break;

		case 'smartSecureMaskInput':
		case 'smartMaskEditor':
			array.mask = (className == "smartSecureMaskInput" ? el.data('editmodemask') : el.data('inputmask')).toString();

			var autocompleteVal = el.attr('autocomplete');
			el.kendoMaskedTextBox(array);
			el.attr('autocomplete', autocompleteVal);
			el.parent().removeClass('form-control');

			if (el.prop('readOnly') || el.prop('disabled')) {
				el.data('kendoMaskedTextBox').readonly();
				el.prop('disabled', 'disabled');
				el.prop('readOnly', true);
			}

			el.editMode = className == "smartSecureMaskInput" ? false : true;

			curVal = htmlElement.get_value();
			var curMask = GetCurrentMask(curVal, el);

			if (curVal && curMask) {
				el.removeClass('placeholderMask');
				htmlElement.set_option({ mask: curMask });
				htmlElement.set_value(curVal, curMask);
			}
			else {
				el.addClass('placeholderMask');
				htmlElement.value = el.data('kendoMaskedTextBox')._emptyMask;
			}

			var value = el.data('kendoMaskedTextBox').raw().replace(/_/g, '');
			var text = el.data('kendoMaskedTextBox').value().replace(/_/g, '');

			if (text.indexOf('*') == -1) {
				$("#" + el.data('controlvalueid')).val(value);
				if (value.length) {
					$("#" + el.data('controltextid')).val(text);
				}
			}

			break;
	}

	var input = el.find('input');
	if (input.attr('name') === null || input.attr('name') === void 0) input.attr('name', el.attr('name'));

	// Event handlers
	switch (className) {
		case 'smartAutoComplete':
			htmlElement.AutoCompleteChanged = function (event) {
				event.stopImmediatePropagation();
				event.preventDefault();

				var itemValue = el.val();
				var itemId = el.jqxComboBox('getSelectedItem') && el.jqxComboBox('getSelectedItem').originalItem ? el.jqxComboBox('getSelectedItem').originalItem.id : null;

				if (el.data('selectedvalueid')) {
					$("#" + el.data('selectedvalueid')).val(itemValue);
				}
				if (el.data('redirecturl')) {
					if (el.data('redirecturl').indexOf('doPostBack') != -1) {
						Function.evaluate(el.data('redirecturl'));
					} else {
						var itemToPass = itemId;
						if (itemToPass == null) itemToPass = itemValue;
						window.location = el.data('redirecturl').replace('REPLACE_ME', itemToPass);
					}
				}
				if (el.prop('tagName') === 'SELECT') el.change();
			}

			var downHandler = function (event) {
				if (event.keyCode === 40) {
					if (el.jqxComboBox('isOpened')) return;
					el.jqxComboBox('search');
					el.jqxComboBox('open');
					el.data('isopened', true);
				}
			};
			var m = (el.prop('tagName') === 'SELECT') ? el.next() : el;
			if (el.caseSelect) {
				m.keyup(function (event) {
					if (event.keyCode === 13) {
						var delay = el.jqxComboBox('remoteAutoCompleteDelay') + 200;
						setTimeout(function () {
							if (event.args === void 0) {
								var item = el.jqxComboBox('getItems').find(function (i) { return i.label == el.val() || i.value == el.val(); });
								if (item === void 0 || item === null || el.val() === el.data('prevval')) {
									el.val(el.data('prevval'));
									return;
								}
								else el.jqxComboBox('selectIndex', item.index);
							}
							htmlElement.AutoCompleteChanged(event);
						}, delay);
					} else downHandler.call(htmlElement, event);
				});

				m.off('change').on('change', function (event) {
					if (event.args === void 0) return;
					if (event.args.type === "mouse") htmlElement.AutoCompleteChanged(event);
				});
				m.off('paste.selerix').on('paste.selerix', function () {
					m.PasteText(event);
				});
				m.PasteText = function (event) {
					if (window.clipboardData === void 0) return;
					el.jqxComboBox('search', window.clipboardData.getData('Text'));
				};
			}
			else {
				m.off('change').on('change', function (event) {
					htmlElement.AutoCompleteChanged(event);
				});
				m.keyup(downHandler);
			}

			m.find('div[role="button"]').click(function (event) {
				if (el.find('input[type="textarea"]').is(':disabled')) return;
				if (el.data('isopened') === true) el.data('isopened', false);
				else el.jqxComboBox('search');
			});

			var dropDownWidth = parseInt(el.width());
			var items = el.jqxComboBox('getItems');
			$(items).each(function () {
				var curWidth = parseInt(this.width) || 0;
				dropDownWidth = Math.max(dropDownWidth, curWidth);
			});

			if (dropDownWidth != parseInt(el.width())) dropDownWidth += 24;
			el.jqxComboBox({ dropDownWidth: Math.min(dropDownWidth, 450) });

			el.find('input').off('focus.selerix').on('focus.selerix', function (event) {
				event.preventDefault();
				if (!$.isWindow(htmlElement))
					el.attr('data-prevval', el.val());
				setSelectionRange(this, 0, 9999);
			});
			break;

		case 'smartTextEditor':
			el.off('focus.selerix').on('focus.selerix', function (event) {
				event.preventDefault();
				if (!$.isWindow(htmlElement))
					el.attr('data-prevval', el.val());
				setSelectionRange(this, 0, 9999);
			});
			break;

		case 'smartNumericEditor':
		case 'smartPercentEditor':
		case 'smartCurrencyEditor':
			el.find('input').off('focus.selerix').on('focus.selerix', function (event) {
				el.data('blurred', false);

				if (!$.isWindow(htmlElement))
					el.attr('data-prevval', el.val());
			});

			el.off('valueChanged.selerix').on('valueChanged.selerix', function (event) {
				// update observable if this is a knockout binding
				if (typeof el.updateObservable === "function")
					el.updateObservable(el.val());
			});

			$(function () {
				if (el.val() > 0) {
					el.trigger('focusout.selerix');
				}
			});

			el.off('focusout.selerix').on('focusout.selerix', function () {
				if (el.data('blurred')) return;
				el.data('blurred', true);
			});
			el.find('input').keydown(function (event) {
				if (event.keyCode != 9) el.valChanged = true;
			});
			break;

		case 'smartTimeEditor':
			el.off('close.selerix').on('close.selerix', function (event) {
				el.find('input').blur();
			});
			break;

		case 'smartDateEditor':
		case 'smartDatePicker':
			el.off('valueChanged.selerix').on('valueChanged.selerix', function (event) {
				// update observable if this is a knockout binding                
				if (typeof el.updateObservable === "function")
					el.updateObservable(htmlElement.get_value());
			});

			el.off('paste.selerix').on('paste.selerix', function () {
				var data = window.clipboardData !== void 0 ? window.clipboardData.getData('Text') : null;

				if (data !== null) {
					el.PasteText(data);
				} else {
					navigator.clipboard.readText()
						.then(function (t) {
							el.PasteText(t);
							el.focus();
						})
						.catch(function (err) { console.error(err); });
				}

			});

			el.PasteText = function (data) {
				if (!data) { return; }

				el.valChanged = true;
				htmlElement.set_value(null);
				setTimeout(function () {
					var pastedText = ZeroPadDateString(data);
					if (pastedText && pastedText.length === 8 & pastedText.indexOf('/') === -1) {
						pastedText = pastedText.substring(0, 2) + '/' + pastedText.substring(2, 4) + '/' + pastedText.substring(4, 8);
					}

					htmlElement.set_value(pastedText);
				}, 0);

				el.fireChangeEvent();
			};

			break;

		case 'smartSecureMaskInput':
		case 'smartMaskEditor':
			el.off('paste.selerix').on('paste.selerix', function () {
				var data = window.clipboardData !== void 0 ? window.clipboardData.getData('Text') : null;

				if (data !== null) {
					el.PasteText(data);
				} else {
					navigator.clipboard.readText()
						.then(function (t) {
							el.PasteText(t);
							el.focus();
						})
						.catch(function (err) { console.error(err); });
				}
			});

			el.PasteText = function (data) {
				if (!data) { return; }
				setTimeout(function () {
					var pastedText = data;
					var mask = (el.data('editmodemask') || '').toString();

					var text = '';
					var j = 0;

					for (var i = 0; i < mask.length; i++) {
						if (pastedText.length <= j) break;
						if (mask.charAt(i) == '*' ||
							mask.charAt(i) == "X" ||
							mask.charAt(i) == "m" ||
							mask.charAt(i) == "n" ||
							mask.charAt(i) == "K" ||
							mask.charAt(i) == "k" ||
							mask.charAt(i) == "L" ||
							mask.charAt(i) == "0" ||
							mask.charAt(i) == "A" ||
							mask.charAt(i) == "C" ||
							mask.charAt(i) == "?" ||
							mask.charAt(i) == "#" ||
							mask.charAt(i) == "9" ||
							mask.charAt(i) == "a" ||
							mask.charAt(i) == "&" ||
							mask.charAt(i) == ">" ||
							mask.charAt(i) == "<"
						) {
							while (pastedText.charAt(j) == '-' ||
								pastedText.charAt(j) == '(' ||
								pastedText.charAt(j) == ')' ||
								pastedText.charAt(j) == '_'
							) {
								j++;
							}
							text += pastedText.charAt(j++);
						}

						else {
							text += mask.charAt(i);
							if (mask.charAt(i) == pastedText.charAt(i)) j++;
						}
					}
					if (text == '') text = pastedText;
					htmlElement.set_value(text);
				}, 0);
			};

			el.off('focus.selerix').on('focus.selerix', function () {
				var curVal = htmlElement.get_value();

				if (!$.isWindow(htmlElement)) el.attr('data-prevval', curVal);

				if (className == "smartSecureMaskInput") {
					el.editMode = true;
					htmlElement.set_option({ mask: el.data('editmodemask').toString() });
				}
				else htmlElement.set_option({ mask: el.data('inputmask').toString() });

				if (curVal)
					htmlElement.set_value(curVal);
				else
					htmlElement.value = el.data('kendoMaskedTextBox')._emptyMask;

				setSelectionRange(this, 0, 9999);
				el.removeClass('placeholderMask');
			});

			el.off('focusout.selerix').on('focusout.selerix', function () {
				curVal = el.data('kendoMaskedTextBox').raw().replace(/_/g, '');
				var curMask = GetCurrentMask(curVal, el, className == "smartSecureMaskInput");

				if (className == "smartSecureMaskInput") {
					el.editMode = false;
				}

				if (curVal && curMask) {
					el.removeClass('placeholderMask');
					htmlElement.set_value(curVal, curMask);
				}
				else {
					el.addClass('placeholderMask');
					htmlElement.value = el.data('kendoMaskedTextBox')._emptyMask;
				}

				if (el.data('inputcase') == "Upper") htmlElement.set_value(htmlElement.get_value().toUpperCase());
				if (el.data('inputcase') == "Lower") htmlElement.set_value(htmlElement.get_value().toLowerCase());
			});

			el.off('change.smartMaskEditor').on('change.smartMaskEditor', function (event) {
				if (!el.data('skipUpdate')) {
					var value = el.data('kendoMaskedTextBox').raw().replace(/_/g, '');
					var text = el.data('kendoMaskedTextBox').value().replace(/_/g, '');

					if (text.indexOf('*') == -1) {
						$("#" + el.data('controlvalueid')).val(value);
						$("#" + el.data('controltextid')).val(text);
					}

					// update observable if this is a knockout binding
					if (typeof el.updateObservable === "function")
						el.updateObservable(value);

					if (htmlElement.get_value()) el.removeClass('placeholderMask');
					else el.addClass('placeholderMask');
				}
			});
			break;
	}

	el.off('change.selerix').on('change.selerix', function (event) {
		var curVal = event.target.value;
		var prevVal = $(event.target).data("prevval");
		if (curVal == prevVal) return;
		if (el.data('valuechanged')) {
			Function.evaluate(el.data('valuechanged') + '(params[0], params[1]);', el, curVal);
		}
		if (el.attr('onchange')) {
			Function.evaluate(el.attr('onchange'));
		}
		if (typeof (htmlElement.onchange) == 'function') el.trigger('onchange');
	});

	el.keydown(function (event) {
		if (el.data('hideenterkey')) {
			if (event.keyCode === 13) return false;
		}

		if (className == 'smartMaskEditor' || className == 'smartSecureMaskInput') {
			if (((event.ctrlKey && event.keyCode === 86) || (event.shiftKey && event.keyCode === 45)) && typeof (el.PasteText) === 'function') {
				var isSecure = className == 'smartSecureMaskInput';
				if (isSecure) {
					htmlElement.set_option({ mask: '' });
					el.editMode = true;
				}

				var data = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;
				var text = data !== void 0 ? data.getData('Text') : null;

				if (text !== null) {
					el.PasteText(text);
					if (isSecure) htmlElement.set_option({ mask: el.data('editmodemask').toString() });
				}
				else if (navigator.clipboard) {
					navigator.clipboard.readText()
						.then(function (t) {
							el.PasteText(t);
							el.focus();
							if (isSecure) htmlElement.set_option({ mask: el.data('editmodemask').toString() });
						})
						.catch(function (err) { console.error(err); });
				}
			}
		}
	});

	if (el.is("div")) {
		var elId = el.attr("id");
		el.attr("id", elId + "_container");
		var inputField = el.find("input");
		inputField.attr("id", elId);
		if (el.attr('readonly') === 'readonly' || el.attr('disabled')) {
			inputField.attr('readonly', 'readonly');
			inputField.attr('disabled', 'disabled');
			inputField.addClass('jqx-input-disabled jqx-fill-state-disabled');
		}
	}

	var innerEl = el.find('input');
	if (innerEl.length) {
		var innerHtmlElement = innerEl[0];
		innerHtmlElement.get_value = function () {
			return htmlElement.get_value();
		}
		innerHtmlElement.set_value = function (value) {
			htmlElement.set_value(value);
		}
		innerHtmlElement.set_option = function (options) {
			return htmlElement.set_option(options);
		}
	}
	el.attr('data-initialized', 'true');
	return el;
}

function ZeroPadDateString(value) {
	if (!value || typeof value !== 'string') return null;
	// left pad each section with 0's
	var curVals = value.split("/");
	$.each(curVals, function (key, val) {
		var section = val.replaceAll('_', '');
		if (section.match(/\d+/g) && section.length < 2) {
			section = section.length == 1 ? '0' + section : section;
		}
		curVals[key] = section;
	});
	return curVals.join('/');
}

function GetCurrentMask(curVal, el, readMode) {
	var inputMask = (readMode ? el.data('readmodemask') : el.data('inputmask')).toString();

	if (curVal instanceof Date) curVal = el[0].get_text();
	if (!curVal) return '';

	var newInputMask = '';
	var j = curVal.length;
	var i = 0;
	var maskChars = ['a', 'l', '0', '9', '#', '*'];
	while (j > 0) {
		if ($.inArray(inputMask.charAt(i).toLowerCase(), maskChars) != -1 || i > inputMask.length) {
			j--;
		}
		newInputMask += inputMask.charAt(i);
		i++;
	}
	if (j == curVal.length) newInputMask = '';

	return newInputMask;
}

function fireDefaultButton(event, element) {
	if (element &&
		(((element.tagName.toLowerCase() == 'input' || element.tagName.toLowerCase() == 'button') && (element.type.toLowerCase() == 'submit' || element.type.toLowerCase() == 'button' || (typeof (element.click) !== void 0 && element.type.toLowerCase() == 'image'))) ||
			(element.tagName.toLowerCase() == 'a' && element.href != null && element.href != '') || (element.tagName.toLowerCase() == 'textarea')))
		return true;

	var defaultButton;
	if ($('#gDefaultButtonID').length > 0 && $('#gDefaultButtonID').val()) {
		defaultButton = $get($('#gDefaultButtonID').val());
	}
	else {
		var btnMain = $(':focus').closest(':has(.btn-main)').find('.btn-main:visible:enabled:first');
		btnMain = btnMain.length ? btnMain : $('body').find('.btn-main:visible:enabled').last();
		defaultButton = btnMain.length ? btnMain : null;
	}
	if (defaultButton && typeof (defaultButton.click) !== void 0) {
		defaultButton.click();
		return false;
	}
	return true;
}

function getSelerixButtonCtrlById(id) {
	var button = {};
	var element = $('#' + id);
	if (element.length === 0) return null;

	button.setEnabled = function (isEnabled) {
		var enabled = isEnabled;
		if (typeof isEnabled === 'string') enabled = isEnabled.toLowerCase() === 'true';
		if (element.attr('data-imageId')) {
			if (enabled) $('#' + element.attr('data-imageId')).attr('src', element.attr('data-standardImage'));
			else $('#' + element.attr('data-imageId')).attr('src', element.attr('data-disabledImage'));
		}
		if (!enabled) element.attr('disabled', 'disabled').addClass('disabled');
		else element.removeAttr('disabled').removeClass('disabled');
	};
	button.getEnabled = function () { return !element.is('[disabled]'); };
	button.setAttribute = function (attribute, value) {
		if (value) element.attr(attribute, value);
		else element.removeAttr(attribute);
	}

	if (!element.is('[onclick]') && element[0].clickEvent === void 0) {
		element[0].clickEvent = function (event) {
			var valid = button.getEnabled();
			if (!valid)
				return false;
			var js;
			if (element.is('[data-confirmationMessage]')) {

				var response = true;
				if (element.attr('data-confirmationMessage')) response = window.confirm(element.attr('data-confirmationMessage'));
				if (element.attr('data-confirmMethod')) {
					response = Function.evaluate('return ' + element.attr('data-confirmMethod') + '();');
				}
				if (element.attr('data-autoHideBusyBox')) {
					var delay = 4000;
					if (Page_BusyBoxDelay) delay = Page_BusyBoxDelay + 100;
					setTimeout('if (Page_BusyBox) { Page_BusyBox.Hide(); }', delay);
				}

				if (response && element.attr('data-clickScript')) {
					var result = Function.evaluate('return ' + element.attr('data-clickScript'));
					if (result === false) return result;
				}
				if (!response) event.stopImmediatePropagation();

				return response;
			}
			return true;
		};
		element.click(element[0].clickEvent);
	}
	return button;
}

function setLanguage(languageID) {
	ajaxJson('POST', selerix.applicationRoot + 'Metadata/SetLanguage', JSON.stringify({ languageID: languageID }), function (data) {
		if (!data) {
			createDialog('There was an error changing languages. Please try again.');
		} else if (typeof selerix.globals.textBankAutoPost === 'function') {
			selerix.globals.textBankAutoPost();
		} else {
			if (selerix.enrollmentSession) {
				selerix.enrollmentSession.isSameOrigin = true;
			}
			location.reload(true);
		}
	});
}

function cleanUpModals() {
	if ($('[data-show="true"]').length === 0) {
		$('body').removeClass('modal-open');

		var bsModals = ($('<div/>').data('bs.modal') || {});
		if (bsModals && bsModals.length) {
			bsModals.each(function (modal) {
				if (modal.isShown || modal._isShown) {
					modal.modal('hide');
				}
			});
		}
		$('.modal-backdrop.modal-stack').remove();
	}
}

function initializeJqxEditors() {
	$('.smartTimeEditor').each(function () { CreateEditor($(this), 'smartTimeEditor'); });
	$('.smartDateEditor').each(function () { CreateEditor($(this), 'smartDateEditor'); });
	$('.smartDatePicker').each(function () { CreateEditor($(this), 'smartDatePicker'); });
	$('.smartCurrencyEditor').each(function () { CreateEditor($(this), 'smartCurrencyEditor'); });
	$('.smartPercentEditor').each(function () { CreateEditor($(this), 'smartPercentEditor'); });
	$('.smartNumericEditor').each(function () { CreateEditor($(this), 'smartNumericEditor'); });
	$('.smartAutoComplete').each(function () { CreateEditor($(this), 'smartAutoComplete'); });
	$('.smartMaskEditor').each(function () { CreateEditor($(this), 'smartMaskEditor'); });
	$('.smartSecureMaskInput').each(function () { CreateEditor($(this), 'smartSecureMaskInput'); });
	$('.smartTextEditor').each(function () {
		switch ($(this).attr('data-textMode') || null) {
			case 'password':
				CreateEditor($(this), 'smartPasswordEditor');
				break;

			case 'multiline':
				CreateEditor($(this), 'smartMultilineEditor');
				break;

			default:
				CreateEditor($(this), 'smartTextEditor');
				break;
		}
	});
}

// ---------------------------------------------------------
// Initialize controls
// ---------------------------------------------------------
function initializeLocalizationPage() {

	if (Modernizr.ischrome) {
		disableAutocomplete();
	}

	// set datatables error mode to throw instead of alert
	if ($.fn.dataTableExt) {
		$.fn.dataTableExt.sErrMode = 'throw';
	}

	var d = new Date();
	$.cookie('TimeZoneOffset', d.getTimezoneOffset(), { expires: 2, path: '/' });

	//  disable autocomplete
	$('form').attr('autocomplete', 'off');
	initializeJqxEditors();

	$('*[data-toggle="modal"][data-target]').each(function () {
		var m = $($(this).data('target'));
		if (!m.data('initialized')) {
			m.off('show.bs.modal').on('show.bs.modal', function () { m.modal('onShow'); });
			m.off('shown.bs.modal').on('shown.bs.modal', function () { m.modal('onShown'); });
			m.off('hide.bs.modal').on('hide.bs.modal', function () { m.modal('onHide'); });
			m.off('hidden.bs.modal').on('hidden.bs.modal', function () { m.modal('onHidden'); });
			m.attr('data-initialized', 'true');
		}
	});

	$('span:has(> input.btn), span:has(> button.btn)').each(function () { //.smartButton class is gone!
		$(this)[0].getEnabled = function () {
			if ($(this).attr('disabled')) return $(this).attr('disabled').toLowerCase() != "disabled";
			return true;
		};

		$(this).click(function (event) {
			if ($(this).attr('data-disableUntilProcessed')) {
				if ($(this).attr('data-processed') && $(this).attr('data-processed').toLowerCase() == 'true') {
					$(this).removeAttr('data-processed');
					return false;
				}
				$(this).attr('data-processed', 'true');
			}
			if (!$(this)[0].getEnabled()) {
				event.stopImmediatePropagation();
				return false;
			}

			var response = true;
			if ($(this).attr('data-confirmationMessage')) response = window.confirm($(this).attr('data-confirmationMessage'));
			if ($(this).attr('data-confirmMethod')) {
				response = Function.evaluate('return ' + $(this).attr('data-confirmMethod') + '();');
			}
			if ($(this).attr('data-autoHideBusyBox')) {
				var delay = 4000;
				if (Page_BusyBoxDelay) delay = Page_BusyBoxDelay + 100;
				setTimeout('if (Page_BusyBox) { Page_BusyBox.Hide(); }', delay);
			}

			if (response && $(this).attr('data-clickScript')) {
				var result = Function.evaluate('return (function() {' + $(this).attr('data-clickScript') + '})();');
				if (result === false) return result;
			}

			if ((!Page_IsValid || Page_BlockSubmit) && $(this).attr('data-causesvalidation') == "true") {
				event.returnValue = false;
				event.cancelBubble = true;
				event.preventDefault();
				return false;
			}
			return response;
		});

		$(this).hover(function (event) {
			if ($(this).attr('data-imageId')) {
				var img = '';
				if ($(this)[0].getEnabled()) {
					if ($(this).attr('data-hoverImage')) img = $(this).attr('data-hoverImage');
				} else img = $(this).attr('data-disabledImage');

				if (img) $('#' + $(this).attr('data-imageId')).attr('src', img);
			}
		});
	});

	$('div.smartTreeGrid').each(function () { createSmartTreeGrid($(this)); });

	initializeSliders();

	// check for ENTER key press
	$(document).keydown(function (e) {
		var result = true;
		if (e.keyCode == 13) {
			var src = e.srcElement || e.target;
			result = (document.activeElement == null || document.activeElement.type != "search") ? fireDefaultButton(e, src) : null;
			if (!result) {
				e.cancelBubble = true;
				if (e.stopImmediatePropagation) e.stopImmediatePropagation();
			}
		}
		return result;
	});

	//style buttons
	//$('input[type=submit], input[type=button], button').button();

	//datatables
	$('.dataTable').each(function () {
		if ($(this).data("initialize") === false) return;
		makeSelerixDataTable(this);
	});

	// Selerix Quick Tabs
	$('.quickTabs').each(function () {
		if ($(this).data('initialize') !== false) initQuickTabs(this);
	});

	if ($('.quickTabs').length > 0) {
		$('.ui-tabs-anchor').click(function () {
			$('div.slider').trigger('refresh');
		});
	}
	//busy box 
	if (Page_BusyBox) {
		// fixes for unbidden BusyBox goes here...
		$('body > header a[href*="ShowDocument.aspx"]').click(function () {
			window['Page_BusyBoxBypass'] = true;
		});

		var oldBeforeUnload = window.onbeforeunload;

		window.onbeforeunload = function () {
			if (window.Page_BusyBoxBypass ||
				document.activeElement && (document.activeElement.getAttribute('href') || '').startsWith('mailto:')) {
				window.Page_BusyBoxBypass = false;
				return;
			}
			if (typeof (Page_IsValid) == "undefined" || Page_IsValid) Page_BusyBox.Show(Page_BusyBoxDelay);
			if (oldBeforeUnload && typeof (oldBeforeUnload) == 'function') oldBeforeUnload();
		}
		if (typeof (Sys) != 'undefined' && !RequestHandlerSet) {
			Sys.WebForms.PageRequestManager.getInstance().add_beginRequest(BeginRequestHandler);
			Sys.WebForms.PageRequestManager.getInstance().add_endRequest(EndRequestHandler);
			RequestHandlerSet = true;
		}
	}

	// show hidden links on focus for 508 compliance
	$('.AuralText').off('focus.AuralText').on('focus.AuralText', function () {
		$(this).addClass('AuralTextVisible');
	}).off('blur.AuralText').on('blur.AuralText', function () {
		$(this).removeClass('AuralTextVisible');
	});

	// 508 compliant menu key navigation
	$('#menu').off('keydown.menu').on('keydown.menu', function (e) {
		switch (e.which) {
			case 37:
			case 38:
			case 39:
			case 40:
				e.preventDefault();
				return;

			default: return;
		}
	});

	$('#menu').off('keyup.menu').on('keyup.menu', function (e) {

		var currentLi = $(':focus').closest('li');
		var isTopLevelItem = currentLi.parent('#topMenu').length;
		var itemIndex = currentLi.index('#topMenu li');

		var currentTopLevelItem;
		var prevTopLevelIndex;
		var nextTopLevelIndex;

		if (isTopLevelItem) {
			prevTopLevelIndex = currentLi.prev('li').index('#topMenu li');
			nextTopLevelIndex = currentLi.next('li').index('#topMenu li');
		}
		else {
			prevTopLevelIndex = currentLi.closest('.sub-menu').parent('li').prev('li').index('#topMenu li');
			nextTopLevelIndex = currentLi.closest('.sub-menu').parent('li').next('li').index('#topMenu li');
		}

		if (nextTopLevelIndex < 0) nextTopLevelIndex = $('#topMenu li').length - 1;

		var i = 0;
		switch (e.which) {
			case 37: // left
				itemIndex = prevTopLevelIndex;
				break;

			case 38: // up
				if (isTopLevelItem) itemIndex = currentLi.prev('li').index('#topMenu li');
				else itemIndex -= 1;

				if (itemIndex < 10000) while (!$('#topMenu li').eq(itemIndex).children('a').length && i < 10) {
					itemIndex--; i++;
				}
				break;

			case 39: // right
				itemIndex = nextTopLevelIndex;
				break;

			case 40: // down
				itemIndex += 1;

				if (itemIndex > 0) while (!$('#topMenu li').eq(itemIndex).children('a').length && i < 10) {
					itemIndex++; i++;
				}
				break;

			default:
				MenuHandler();
				return;
		}

		if (itemIndex > $('#topMenu li').length - 1) itemIndex = $('#topMenu li').length - 1;
		if (itemIndex < 0) itemIndex = 0;

		$('#topMenu li').eq(itemIndex).children('a').focus();

		currentLi = $('#topMenu li').eq(itemIndex).children('a').closest('li');
		MenuHandler();

		function MenuHandler() {
			$('#topMenu li').each(function () {
				if ($(this).children('.sub-menu').length) {
					$(this).attr('aria-expanded', 'false');
					$(this).attr('aria-haspopup', 'true');
				}
			});

			isTopLevelItem = currentLi.parent('#topMenu').length;

			if (isTopLevelItem) currentTopLevelItem = $(':focus');
			else currentTopLevelItem = currentLi.closest('.sub-menu').prev('a');

			$('#topMenu').find('a').removeClass('menu-hover');
			currentTopLevelItem.addClass('menu-hover');

			if (currentTopLevelItem.next('.sub-menu').length) currentTopLevelItem.parent('li').attr('aria-expanded', 'true');
		}
	});

	$('#topMenu li a').off('mouseover.menu').on('mouseover.menu', function () {
		$('#topMenu').find('a').removeClass('menu-hover');
	});

	// create dialog from data-confirm attribute
	$("[data-confirm]:not([data-bind~='confirm:']):not([data-bind~='click:'])").each(function () {
		var el = $(this);
		el.off('click.confirm').on('click.confirm', function (event, eventConfirmed) {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();

			if (!eventConfirmed) {
				createDialog(el.attr("data-confirm"), function (confirmed) {
					if (confirmed) {
						var link = el.attr('href');
						if (link) window.location.href = link;
						else el.trigger("click", true);
					}
				});
			}
		});
	});

	// Charts
	$(selerix.globals.charts).each(function (key, chart) {
		createChart(chart.chartID, chart.width, chart.height, chart.data, chart.showLegend, chart.chartType);
	});

	// responsive tables overlay
	initTableResponsive();

	if (Modernizr.ismicrosoft) {
		$('input[type="number"]').prop('type', 'text');
	}

	$('.application-rider button.expander').off('click.rider').on('click.rider', function () {
		var el = $(this);
		if (el.hasClass('collapsed') && !el.hasClass('collapse')) {
			el.removeClass('expand').addClass('collapse');
		} else if (!el.hasClass('expand')) {
			el.removeClass('collapse').addClass('expand');
		}
	});

	$('.input-group').each(function () {
		var g = $(this), b = g.find('.input-group-btn > .btn'), t = g.find('.form-control');
		if (b.is(':enabled')) {
			t.on('keydown.group.btn', function (event) {
				var keyCode = (event.which ? event.which : event.keyCode);
				if (keyCode === 13) {
					event.preventDefault();
					b.click();
					return false;
				}
				return true;
			});
		}
	});

	$('.coverage-details button.expander').off('click.details').on('click.details', function () {
		var el = $(this);
		if (!el.hasClass('collapse')) {
			el.removeClass('expand').addClass('collapse');
			el.attr('aria-expanded', 'true');
		} else if (!el.hasClass('expand')) {
			el.removeClass('collapse').addClass('expand');
			el.attr('aria-expanded', 'false');
		}
	});

	for (var i = 0; i < PageLoadScripts.length; i++) {
		if (typeof PageLoadScripts[i] === 'function') {
			PageLoadScripts[i]();
		}
	}
}

var PageLoadScripts = [];

var initTableResponsive = function () {
	$('.table-responsive').each(function () {
		var tbl = this;
		if ($(tbl).data('initialize') === false) return;

		var overlay = $('<DIV/>').addClass('scrollable scroll-right');
		$(tbl).prepend(overlay);
		if ((tbl.scrollWidth - 1) === $(tbl).width()) overlay.hide();

		overlay.click(function () {
			if ($(this).hasClass('scroll-left')) $(tbl).scrollLeft(0);
			else $(tbl).scrollLeft(tbl.scrollWidth - 1 - $(tbl).width());
		});
		$(tbl).scroll(function () {
			if ($(tbl).scrollLeft() >= tbl.scrollWidth - 1 - $(tbl).width()) overlay.removeClass('scroll-right').addClass('scroll-left');
			else if ($(tbl).scrollLeft() === 0) overlay.removeClass('scroll-left').addClass('scroll-right');

			$(tbl).children('.scroll-left').css({ right: 'auto', left: ($(tbl).scrollLeft() - 1) + 'px' });
			$(tbl).children('.scroll-right').css({ left: 'auto', right: (-$(tbl).scrollLeft() - 1) + 'px' });
		});
	});
	$(window).on('resize.table-responsive', function () {
		$('.table-responsive').each(function () { recalcTableResponsive(this); });
	});
};
var recalcTableResponsive = function (el) {
	$(el).scrollLeft(0);
	var overlay = $(el).children('.scrollable');
	if ((el.scrollWidth - 1) > $(el).width()) overlay.show();
	else overlay.hide();
};

function initializeSliders(withinContainer) {
	withinContainer = withinContainer || '';
	$(withinContainer + ' div.slider').each(function () {
		var self = $(this);
		this.warning = null, this.danger = null, this.range = null;

		var id = self.attr('id').removeLast('_Slider');
		var root = $('#' + id);
		var hdn = $('#' + id + '_Selected');
		var items = window[id + '_Items'];
		var isInitial = true, isSliding = false, isKeyDown = false;
		var onChangeDelay;
		var onChangeDelayInitial = onChangeDelay = 30, onChangeTimer = 0, onChangeInterval = null;
		var hdn_val = hdn.val().indexOf('|') > -1 ? hdn.val().split('|')[1] : hdn.val();
		var changeAction = 'change';

		// associate label w/ slider control
		$('label[for="' + id + '"]').each(function () {
			$(this).attr('for', self.attr('id'));
			$(this).attr('id', id + '_Label');
			self.attr('aria-labelledby', $(this).attr('id'));
		});

		// parse json objects
		if (hdn.val() === '') hdn.val(0).trigger('init');
		try {
			if (self.data('warning')) this.warning = JSON.parse(self.data('warning').replaceAll("'", '"').replaceAll('\n', ''));
		} catch (ex) {
			console.log('Slider warning settings failed to parse - ', ex, '\n', self.data('warning'));
		}

		try {
			if (self.data('danger')) this.danger = JSON.parse(self.data('danger').replaceAll("'", '"').replaceAll('\n', ''));
		} catch (ex) {
			console.log('Slider danger settings failed to parse - ', ex, '\n', self.data('danger'));
		}

		try {
			if (self.data('range')) this.range = JSON.parse(self.data('range').replaceAll("'", '"').replaceAll('\n', ''));
		} catch (ex) {
			console.log('Slider range settings failed to parse - ', ex, '\n', self.data('range'));
		}

		var showTooltip = self.data('showtooltip') !== void 0 && self.data('showtooltip');
		if (self.data('tooltiplabels')) showTooltip = false;

		// implement slider control
		self.jqxSlider({
			tooltip: showTooltip,
			showButtons: self.data('showbuttons') != void 0 && self.data('showbuttons'),
			mode: self.data('mode'),
			min: parseFloat(self.data('min')),
			max: parseFloat(self.data('max')),
			ticksFrequency: parseFloat(self.data('frequency')),
			value: items ? Array.findIndex(items, function (i) {
				return i.value == hdn.val();
			}) : parseFloat(hdn_val),
			step: parseFloat(self.data('step')),
			rangeSlider: self.data('rangeenabled') != void 0 && self.data('rangeenabled'),
			values: this.range ? [this.range.min, this.range.max] : [],
			width: this.range ? '60%' : '100%'
		});

		root.data({ value: self.jqxSlider('value') });

		// postback event with time delay
		self.startPostBackTimer = function () {
			onChangeTimer = onChangeDelay;
			if (onChangeInterval === null) {
				onChangeInterval = setInterval(function () {
					if (root.data('value') == self.jqxSlider('value')) {
						return;
					}
					if (isSliding) onChangeTimer = onChangeDelay;
					if (onChangeTimer === 0) {
						clearInterval(onChangeInterval);
						onChangeInterval = null;
						root.trigger('selectedindexchanged', { changeAction: changeAction });
						changeAction = 'change';
					} else onChangeTimer--;
				}, 10);
			}
		};

		var pressed = null;
		// change slider value
		self.on('change', function (event) {
			if (!window.event) {
				Object.defineProperty(window, "event", {
					configurable: true,
					get: function get() {
						return event;
					}
				});
			}
			var labels = $('[id^=' + id + '_Text]');
			var label = labels.length ? $(labels[labels.length - 1]) : labels;

			var p = self.data('precision') || 0;
			label.data('autoOpenToolTip', label.data('autoOpenToolTip') || false);
			if (this.range) {
				var vals = self.jqxSlider('values');
				hdn.val(vals[0] + ',' + vals[1]).trigger('change');
				if (labels.length == 1) label[0].innerHTML = vals[0].formatAs(self.data('format'), p) + ' - ' + vals[1];
				else if (labels.length == 2) {
					labels[0].innerHTML = vals[0].formatAs(self.data('format'), p);
					labels[1].innerHTML = vals[1].formatAs(self.data('format'), p);
				}
			} else {
				var val = self.jqxSlider('value');
				var v = (items && items[val]) ? items[val].value : val;
				hdn.val(v).trigger('change');
				hdn_val = hdn.val().indexOf('|') > -1 ? hdn.val().split('|')[1] : hdn.val();

				if (self.data('textmode') == 'text') {
					label[0].innerHTML = (items && items[val]) ? items[val].text.formatAs(self.data('format'), p) : v.formatAs(self.data('format'), p);
				} else label[0].innerHTML = v.formatAs(self.data('format'), p);
				self.attr('aria-valuetext', label[0].innerHTML);
			}
			// postback event timer
			if (!isInitial && !isSliding && !isKeyDown) { self.startPostBackTimer(); }
			else if (self.data('change') && !isInitial) window[self.data('change')]();

			// show tooltip warning
			var warnmode = self.data('warnmode') || 'maxrange';
			var max = ((this.danger || this.warning) || { max: -1 }).max;
			var labelID = '#' + label.attr('id');
			var tooltipTemplate = $('<DIV/>').addClass('tooltip').addClass('tooltip-underwriting').attr('role', 'tooltip');

			tooltipTemplate.append($('<DIV/>').addClass('tooltip-inner')).append($('<DIV/>').addClass('tooltip-arrow'));


			var customAmountStatus;
			var totalPlace = $('#bodyContent_ucMain_TotalPlace');

			if (totalPlace.length > 0) {
				customAmountStatus = totalPlace.find('.text-danger').length > 0 ? 'danger' : (totalPlace.find('.text-warning').length > 0 ? 'warning' : undefined);
			}

			if (label.length && warnmode === 'listitems' && items !== void 0 && items.length > 0) {
				// process multiple GI limit themes based on item's theme in array
				// don't calculate theme based on max value. use only the <option/> item class for theme                
				var v1 = self.jqxSlider('value');
				var t = items[v1] ? items[v1].theme : void 0;

				if (t !== void 0 || customAmountStatus !== void 0) {
					t = customAmountStatus !== void 0 ? customAmountStatus : t;

					tooltipTemplate.addClass("tooltip-" + t);

					self.removeClass('jqx-widget-theme-danger').removeClass('jqx-widget-theme-warning').addClass('jqx-widget-theme-' + t);

					label.attr('data-toggle', 'tooltip');

					$(labelID + '[data-toggle= "tooltip"]').tooltip({
						title: this.danger.text,
						container: labelID,
						placement: this.danger.position,
						trigger: 'manual',
						template: tooltipTemplate,
						sanitize: false
					});
					$(labelID + '[data-toggle= "tooltip"]').tooltip('show');

					label.data('autoOpenToolTip', true);
					label.removeClass('text-success').removeClass('text-warning').removeClass('text-danger').addClass('text-' + t);
				} else {
					$(labelID + '[data-toggle= "tooltip"]').tooltip('hide');

					self.removeClass('jqx-widget-theme-danger').removeClass('jqx-widget-theme-warning');
					label.data('autoOpenToolTip', false);
					label.removeClass('text-danger').removeClass('text-warning').addClass('text-success');
				}
			} else if (label.length && this.danger !== null && this.danger !== void 0) {
				if (parseFloat(hdn_val) > this.danger.max) {
					tooltipTemplate.addClass('tooltip-danger');

					label.attr("data-toggle", "tooltip");

					$(labelID + '[data-toggle= "tooltip"]').tooltip({
						title: this.danger.text,
						container: labelID,
						placement: this.danger.position,
						trigger: 'manual',
						template: tooltipTemplate,
						sanitize: false
					});

					$(labelID + '[data-toggle= "tooltip"]').tooltip('show');

					self.removeClass('jqx-widget-theme-warning').addClass('jqx-widget-theme-danger');

					label.data('autoOpenToolTip', true);
					label.removeClass('text-success').removeClass('text-warning').addClass('text-danger');
				} else {
					$(labelID + '[data-toggle= "tooltip"]').tooltip('hide');

					self.removeClass('jqx-widget-theme-danger');
					label.data('autoOpenToolTip', false);
					label.removeClass('text-danger').removeClass('text-warning').addClass('text-success');
				}
			} else if (label.length && this.warning !== null && this.warning !== void 0) {
				if (parseFloat(hdn_val) > this.warning.max) {
					tooltipTemplate.addClass('tooltip-warning');

					label.attr('data-toggle', 'tooltip');

					$(labelID + '[data-toggle= "tooltip"]').tooltip({
						title: this.warning.text,
						container: labelID,
						placement: this.warning.position,
						trigger: 'manual',
						template: tooltipTemplate,
						sanitize: false
					});
					$(labelID + '[data-toggle= "tooltip"]').tooltip('show');

					self.removeClass('jqx-widget-theme-danger').addClass('jqx-widget-theme-warning');

					label.data('autoOpenToolTip', true);
					label.removeClass('text-success').removeClass('text-danger').addClass('text-warning');
				} else {
					$(labelID + '[data-toggle= "tooltip"]').tooltip('hide');

					self.removeClass('jqx-widget-theme-warning');
					label.data('autoOpenToolTip', false);
					label.removeClass('text-warning').removeClass('text-danger').addClass('text-success');
				}
			}

			tooltipTemplate.on("click", function () {
				if ($(this).hasClass('in')) {
					tooltipTemplate.tooltip('hide');
				}
			});

			isInitial = false;
			// hide slider control if <= 1 item(s)
			if ((items !== void 0 && items.length <= 1) || (items === void 0 && self.jqxSlider('min') == self.jqxSlider('max'))) {
				self.hide();
				label.css({ 'margin-left': 0 });
				if (self.data('containerid')) {
					var c = $('#' + self.data('containerid'));
					var crt = c.attr('class');
					var alt = c.data('altclass');
					if (alt) {
						$('#' + self.data('containerid')).switchClass(crt, alt);
						$('#' + self.data('containerid')).attr('data-altclass', crt);
					}
				}
			}
		});

		window.onresize = function () {
			var e = document.createEvent('Event');
			e.initEvent('change', true, true);
			self.context.dispatchEvent(e);
		};

		// set slide flag
		self.on('slideStart', function (event) { isSliding = true; });
		// call postback event or callback on slide end
		self.on('slideEnd', function (event) {
			isSliding = false;
			self.startPostBackTimer();
			changeAction = 'slide';
			if (self.data('slideend')) window[self.data('slideend')]();
		});
		// extend change delay on key down
		self.on('keydown', function (event) {
			isKeyDown = true;
			onChangeDelay = onChangeDelayInitial + 20;
			self.startPostBackTimer();
		});
		// reset change delay on key up
		self.on('keyup', function (event) { isKeyDown = false; onChangeDelay = onChangeDelayInitial; changeAction = 'key'; });
		// knockout binding
		self.on('bind', function (event, value) {
			if (value !== hdn_val) {
				hdn_val = value;

				if (this.range) self.jqxSlider('values', hdn_val.split(','));
				else self.jqxSlider('value', hdn_val);
			}
		});
	});
}

function initQuickTabs(element) {
	var el = $(element);
	if (el.prop('id').length === 0) { el.attr('id', 'tabs_' + (new Guid().segment(4))); }
	if (el.children('nav').length === 0) { el.children('ul').wrap($('<NAV/>').addClass('ui-tabs-nav')); }

	var divs = el.children('nav ~ div');
	el.children('nav').find('ul > li').each(function (i) {
		var div = $(divs[i]), li = $(this);
		if (div.prop('id').length === 0) { div.attr('id', el.prop('id') + '_' + i); }

		var a = li.children('a');
		if (a.length === 0) {
			a = $('<A/>').html(li.html());
			li.html('').append(a);
		}
		if (a.prop('href').length === 0) { a.attr('href', '#' + div.prop('id')); }
	});

	var hdn = el.children('input[type="hidden"]');
	if (hdn.length === 0) { el.prepend(hdn = $('<INPUT/>').attr('type', 'hidden').attr('id', el.prop('id') + '_current').val('0')); }

	var selerixTabs = new SelerixTabs(el.prop('id'));
	selerixTabs.Index = hdn.val();
	selerixTabs.HiddenIndexID = hdn.prop('id');
	selerixTabs.Activate = initTabContent;
	selerixTabs.init();
}

// Tabs need to re-initialize some controls when switching tabs
function initTabContent(event, ui) {
	// Charts
	$(selerix.globals.charts).each(function (key, chart) {
		createChart(chart.chartID, chart.width, chart.height, chart.data, chart.showLegend, chart.chartType);
	});

	// refresh tabs
	ui.newPanel.find('.quickTabs').each(function () {
		if (this.hasOwnProperty('selerixTabs')) { setTimeout(this.selerixTabs.refresh, 0); }
	});
}

var smartTreeGridViewModel = function (value) {
	this.value = ko.observable(value);
	this.setValue = ko.computed({
		read: this.value,
		write: function (value) {
			if (!isNaN(value))
				this.value(parseFloat(value)); // Write to underlying storage
		}, owner: this
	});
};

function createSmartTreeGrid(treeGrid) {
	treeGrid.jqxTreeGrid(
		{
			width: '100%',
			source: dataAdapter,
			filterable: true,
			filterMode: 'simple',
			altRows: true,
			columnsHeight: 36,
			sortable: true,
			columnsResize: true,
			columns: [
				{ text: 'First Name', dataField: 'FirstName', align: 'center', draggable: true, sortable: true, },
				{ text: 'Last Name', dataField: 'LastName', align: 'center', draggable: true, sortable: true, width: 150 },
				{ text: 'Title', dataField: 'Title', align: 'center', draggable: true, sortable: true, width: 150 },
				{ text: 'Birth Date', dataField: 'BirthDate', cellsFormat: 'd', align: 'center', draggable: true, sortable: true, width: 150 },
				{ text: 'Hire Date', dataField: 'HireDate', cellsFormat: 'd', align: 'center', draggable: true, sortable: true, width: 150 }
			]
		});
}

// Charts
function createChart(chartID, width, height, data, showLegend, chartType) {
	var $container = $('#' + chartID);
	if (!$container.is(':visible')) {
		//console.warn('jqxChart with id "' + chartID
		//    + '" was not rendered because the chart container is invisible.');
		return;
	}

	if ($container.width() <= 0 || $container.height() <= 0) {
		//console.warn('jqxChart with id "' + chartID
		//    + '" was not rendered because the chart container has zero size.');
		return;
	}

	showLegend = showLegend.toLowerCase() === 'true' ? true : false;

	var source, dataAdapter, settings;

	switch (chartType) {
		case 'usmap':
			var mp = new LocationMap(chartID, width, height);
			mp.Enabled = false;
			mp.Values.apply(mp, data);
			mp.Draw();
			break;

		case 'pie':
			source = {
				localdata: data,
				datatype: 'array',
				datafields: [
					{ name: 'label', type: 'string' },
					{ name: 'value', type: 'decimal' }
				]
			};

			var dataAdapter = new $.jqx.dataAdapter(source);

			var legendWidth = parseInt(width) * .25;
			var legendHeight = parseInt(height);
			var offsetX;
			var offsetY;
			var radius;

			offsetX = showLegend ? (parseInt(width) / 2) - (legendWidth / 2) : parseInt(width) / 2;
			offsetY = parseInt(height) / 2;
			radius = showLegend ? parseInt(height) * .33 : parseInt(height) * .44;

			var settings = {
				enableAnimations: false,
				showBorderLine: true,
				showLegend: showLegend,
				legendLayout: { left: parseInt(width) - legendWidth, top: 0, width: legendWidth, height: legendHeight, flow: 'vertical' },
				source: dataAdapter,
				colorScheme: selerix.globals.chartScheme,
				backgroundColor: 'none',
				borderColor: 'none',
				title: false,
				description: false,
				padding: { left: 0, top: 0, right: 0, bottom: 0 },
				seriesGroups: [{
					type: 'pie',
					offsetX: offsetX,
					offsetY: offsetY,
					showLabels: true,
					series: [{
						enableSelection: false,
						dataField: 'value',
						displayText: 'label',
						labelRadius: '50%',
						initialAngle: 15,
						radius: radius,
						centerOffset: 0,
						formatFunction: function (value) {
							if (isNaN(value)) return value;
							return parseFloat(value);
						},
					}]
				}]
			};

			if ($('#' + chartID).length) {
				$('#' + chartID).jqxChart(settings);
				if (showLegend) {
					$('#' + chartID).css('height', (parseInt('{2}') * .75));
					$('#' + chartID).find('.chartContainer').css('height', (parseInt('{2}') * .75));
				}
			}
			break;

		case 'bar':
			source =
			{
				localdata: data,
				datatype: 'array',
				datafields: [
					{ name: 'label', type: 'string' },
					{ name: 'value', type: 'decimal' },
				]
			};

			dataAdapter = new $.jqx.dataAdapter(source);
			settings = {
				enableAnimations: false,
				showBorderLine: true,
				showLegend: false,
				source: dataAdapter,
				colorScheme: selerix.globals.chartScheme,
				backgroundColor: 'none',
				borderColor: 'none',
				title: false,
				description: false,
				padding: { left: 0, top: 0, right: 0, bottom: 0 },
				xAxis: {
					dataField: 'label',
					displayText: 'Label',
					gridLines: { visible: true },
					valuesOnTicks: false,
					flip: false
				},
				valueAxis: { flip: true },
				seriesGroups: [{
					type: 'column',
					orientation: 'horizontal',
					series: [{ dataField: 'value', displayText: 'Value' }]
				}]
			};
			if ($('#' + chartID).length) { $('#' + chartID).jqxChart(settings); }
			break;

		case 'column':
			source =
			{
				localdata: data,
				datatype: 'array',
				datafields: [
					{ name: 'label', type: 'string' },
					{ name: 'value', type: 'decimal' },
				]
			};

			dataAdapter = new $.jqx.dataAdapter(source);
			settings = {
				enableAnimations: false,
				showBorderLine: true,
				showLegend: false,
				source: dataAdapter,
				colorScheme: selerix.globals.chartScheme,
				backgroundColor: 'none',
				borderColor: 'none',
				title: false,
				description: false,
				padding: { left: 0, top: 0, right: 0, bottom: 0 },
				xAxis: {
					dataField: 'label',
					displayText: 'Label',
					gridLines: { visible: true },
					valuesOnTicks: false
				},
				seriesGroups: [{
					type: 'column',
					valueAxis: { visible: true },
					series: [{ dataField: 'value', displayText: 'Value' }]
				}]
			};
			if ($('#' + chartID).length) { $('#' + chartID).jqxChart(settings); }
			break;
	}
}

// NOTE: Migrated from globals.d.ts

/**
 * @typedef {Object} NameValuePair
 * @property {string} name
 * @property {string} value
 */

/**
 * @typedef {Object} DialogButton
 * @property {string} text
 * @property {string=} state Determines the class applied to the button.
 * @property {boolean=} closes If set to `false`, clicking the button will not close the modal.
 * 
 * Defaults to `true`.
 * @property {NameValuePair[]=} attr Attributes to set on the button.
 * @property {boolean=} defaultButton
 * @property {() => any=} action Function to call when the button is clicked.
 * 
 * The return value will be passed to the dialog callback.
 */

/**
 * @typedef {Object} DialogShortCodeButton
 * @property {string} text
 * @property {string=} state Determines the class applied to the button.
 * @property {boolean=} closes If set to `false`, clicking the button will not close the modal.
 * 
 * Defaults to `true`.
 * @property {NameValuePair[]=} attr Attributes to set on the button.
 * @property {boolean=} defaultButton
 * @property {() => any=} action Function to call when the button is clicked.
 * 
 * The return value will be passed to the dialog callback.
 * @property {() => any=} click If defined, will overwrite {@link action}.
 */

/**
 * @typedef {Object} DialogConfig
 * @property {string=} customID ID to use for modal element.
 * @property {string=} title Modal title
 * @property {string=} message Modal message
 * @property {string=} type Does nothing
 * @property {string=} state Determines the modal style and icon.
	 * Determines the modal title if {@link title} is not defined.
 * @property {'small'|'medium'|'large'=} size Determines modal size. Defaults to `medium`.
 * 
 * @property {boolean|string=} backdrop If `true`, includes the modal-backdrop element.
 * 
 * If `'static'`, clicking the backdrop does not close the modal.
 * 
 * Defaults to `true`.
 * 
 * @property {boolean=} keepAfterPostback
 * @property {boolean=} hideCancel If {@link buttons} is `undefined`, setting this to `true` will prevent a Cancel button from being shown.
 * 
 * Defaults to `false`.
 * @property {boolean=} keyboard If `true`, the modal can be closed by pressing the Escape key.
 * @property {boolean=} showIcon Whether to show the modal icon. Defaults to `true`.
 * 
 * @property {DialogButton[]=} buttons Custom button definitions. If excluded, will use default OK and Cancel buttons.
 * 
 * @property {DialogShortCodeButton[]=} shortcodeButtons Deprecated parameter: Backwards compatibility for shortcode buttons
 * 
 * @property {(e: JQueryEventObject) => void=} onHide
 * @property {(e: JQueryEventObject) => void=} onHidden
 * @property {(e: JQueryEventObject) => void=} onShow
 * @property {(e: JQueryEventObject) => void=} onShown
 */

/**
 * 508 compliant dialog
 * @param {DialogConfig|string|undefined} params 
 * @param {(x:any)=>void=} callBack 
 * @param {()=>void=} drawCallBack 
 */
function createDialog(params, callBack, drawCallBack) {
	$(':focus').blur();
	var dialogElement = params.customID ? $('[id="' + params.customID + '"]') : null;

	if (!dialogElement) {
		var isAlert = typeof callBack !== 'function';
		var message;
		if (typeof params === 'undefined') { params = 'Are you sure you wish to complete this action?'; }
		if (typeof params === 'string') {
			message = params;
			params = {};
		}

		var defaultButtons = [{
			text: 'OK',
			defaultButton: true,
			action: function () {
				return true;
			}
		}];

		if (!isAlert && !params.hideCancel === true) {
			defaultButtons.push({
				text: 'Cancel',
				action: function () {
					return false;
				}
			});
		}

		var defaultState = isAlert ? 'primary' : 'warning';
		params.title = params.title || null;
		params.message = params.message || message;
		params.customID = params.customID || null;
		params.buttons = params.buttons || defaultButtons;
		params.size = params.size || 'medium';
		params.state = params.state || defaultState;
		params.type = params.type || 'alert';
		params.backdrop = params.backdrop === false ? false : params.backdrop || true;
		params.keyboard = params.keyboard === false ? false : true;
		params.showIcon = params.showIcon === false ? false : true;
		params.keepAfterPostback = params.keepAfterPostback === true ? true : false;

		// Depricated parameter: Backwards compatibility for shortcode buttons
		if (params.shortcodeButtons) {
			$.each(params.shortcodeButtons, function (btnKey, btnObj) {
				if (btnObj.click) btnObj.action = btnObj.click;
			});

			params.buttons = params.shortcodeButtons;
		}

		dialogElement = buildDialogElement(params);

		dialogElement.data('temp', true);
		dialogElement.attr('data-backdrop', params.backdrop);
		dialogElement.attr('data-keyboard', params.keyboard);

		$.each(params.buttons, function (btnKey, btnObj) {
			$('#' + btnObj.curID).off('click.dialog').on('click.dialog', function () {
				if (!isAlert) {
					callBack(btnObj.action());
				}
				else if (typeof btnObj.action === 'function') {
					btnObj.action();
				}

				if (btnObj.closes !== false) {
					dialogElement.modal('hide');
				}
			});
		});
	}

	if (!dialogElement.data('initialized')) {
		dialogElement.data('dcb', drawCallBack);

		dialogElement.close = function () {
			dialogElement.modal('hide');
		}

		dialogElement.off('show.bs.modal').on('show.bs.modal', function (e) {
			dialogElement.modal('onShow');
			if (typeof params.onShow === 'function') params.onShow(e);
		});

		dialogElement.off('shown.bs.modal').on('shown.bs.modal', function (e) {
			dialogElement.modal('onShown');
			if (typeof params.onShown === 'function') params.onShown(e);
		});

		dialogElement.off('hide.bs.modal').on('hide.bs.modal', function (e) {
			dialogElement.modal('onHide');
			if (typeof params.onHide === 'function') params.onHide(e);
		});

		dialogElement.off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
			dialogElement.modal('onHidden');
			if (typeof params.onHidden === 'function') params.onHidden(e);
			if ($('.modal.in').length > 0 && !$('body').hasClass('modal-open')) { $('body').addClass('modal-open'); }
		});

		dialogElement.attr('data-initialized', 'true');
	}

	if (dialogElement.data('show') !== false) {
		dialogElement.modal('show');
	}
	else {
		if ($('.modal.in').length > 0 && !$('body').hasClass('modal-open')) {
			$('body').addClass('modal-open');
		}
		dialogElement.modal();
	}

	return dialogElement;
}

// To satisfy sonarqube bug with global functions needing to be namespaced
// https://sonarqube.office.selerix.com/project/issues?id=BenSelect&issues=AXhEWSpbXla-u28MwU_K&open=AXhEWSpbXla-u28MwU_K
function ExtendSelerixUi() {
	$(document).ready(function () {
		if (selerix && selerix.ui) {
			$.extend(selerix.ui, { createDialog: createDialog });
		}
	});
}
ExtendSelerixUi();

/**
 * Builds and returns dialog element
 * @param {DialogConfig} params 
 */
function buildDialogElement(params) {
	var titleID = 'title_' + selerix.globals.guid();
	var contentContainer;
	if (params.showIcon) {
		contentContainer = $('<div/>').addClass('container-fluid').append(
			$('<div/>').addClass('row').append(
				$('<div/>').addClass(params.size === 'small' ? 'modal-icon col-xs-3 vertical-center' : params.size === 'large' ? 'modal-icon col-xs-1 vertical-center' : 'modal-icon col-xs-2 vertical-center').attr('aria-label', params.icon + ' icon')
			).append(
				$('<div/>').addClass(params.size === 'small' ? 'modal-text col-xs-9 vertical-center' : params.size === 'large' ? 'modal-text col-xs-11 vertical-center' : 'modal-text col-xs-10 vertical-center')
			)
		);
	}
	else {
		contentContainer = $('<div/>').addClass('modal-text');
	}

	var dialogElement = $('<div/>').addClass('modal fade').attr('tabindex', '-1').attr('role', 'dialog').attr('aria-labelledby', titleID).attr('aria-label', params.title).append(
		$('<div/>').addClass('modal-dialog').attr('role', 'document').append(
			$('<div/>').addClass('modal-content').append(
				$('<div/>').addClass('modal-header bg-' + params.state).append(
					$('<button/>').addClass('close').attr('type', 'button').attr('data-dismiss', 'modal').attr('aria-label', 'Close').append(
						$('<span/>').addClass('bg-' + params.state).attr('aria-hidden', 'true').append('&times;')
					)
				).append(
					$('<h4/>').addClass('modal-title').attr('id', titleID)
				)
			).append(
				$('<div/>').addClass('modal-body').append(contentContainer)
			).append(
				$('<div/>').addClass('modal-footer')
			)
		)
	);

	var icon = $('<span></span>').css('font-size', '48px').css('margin-top', '7px');
	switch (params.state) {
		case 'default':
			icon.addClass('icon-default');
			params.title = params.title || 'Information';
			break;

		case 'primary':
			icon.addClass('icon-primary');
			params.title = params.title || 'Information';
			break;

		case 'success':
			icon.addClass('icon-success');
			params.title = params.title || 'Success';
			break;

		case 'info':
			icon.addClass('icon-info');
			params.title = params.title || 'Information';
			break;

		case 'danger':
			icon.addClass('icon-danger');
			params.title = params.title || 'Danger';
			break;

		case 'warning':
			icon.addClass('icon-warning');
			params.title = params.title || 'Warning';
			break;

		case 'unlock':
			icon.addClass('selerix-unlock');
			params.title = params.title || 'Warning';
			break;
	}

	if (params.size !== 'medium') {
		if (params.size === 'large')
			dialogElement.find('.modal-dialog').addClass('modal-lg');
		else
			dialogElement.find('.modal-dialog').addClass('modal-sm');
	}

	if (params.keepAfterPostback) dialogElement.attr('data-show', 'true');

	if (params.showIcon) dialogElement.find('.modal-icon').html(icon);

	dialogElement.find('.modal-title').html(params.title);
	dialogElement.find('.modal-text').html(params.message);

	$.each(params.buttons, function (btnKey, btnObj) {
		var curID = 'dialog_btn_' + selerix.globals.guid();
		btnObj.curID = curID;
		var curButton;

		if (btnObj.id) {
			curButton = $('#' + btnObj.id);
			btnObj.curID = btnObj.id;
		}
		else {
			curButton = $('<button/>').addClass('btn btn-sm').html(btnObj.text).attr('id', curID).attr('type', 'button');
		}
		curButton.attr('aria-label', btnObj.text + ' button');

		if (btnObj.attr) {
			$.each(btnObj.attr, function (attrKey, attrObj) {
				curButton.attr(attrObj.name, attrObj.value);
				if (attrObj.name == 'id') btnObj.curID = attrObj.value;
			});
		}

		if (btnObj.defaultButton) {
			curButton.addClass('btn-main');
		} else if (btnObj.state) {
			curButton.addClass('btn-' + btnObj.state);
		} else {
			curButton.addClass('btn-default');
		}

		dialogElement.find('.modal-footer').append(curButton);
	});


	$('body').prepend(dialogElement);

	return dialogElement;
}

// ---------------------------------------------------------
// Initialize controls
// ---------------------------------------------------------
function postInitializeLocalizationPage() {
	if (Modernizr.ischrome) {
		disableAutocomplete();
	}
	$('.jqx-tooltip').remove();
	$('div.slider').each(function () { $(this).change(); });
	$('.slx-autocomplete').each(function () { $(this).slxAutoComplete(); });
	$('.slx-dateselector').each(function () { $(this).slxDateSelector(); });

	// add validators to created controls
	$.each(Page_Validators, function (key, validator) {
		AddValidator(validator);
	});

	if ($('#gDefaultButtonID').val()) {
		var btn = $('#' + $('#gDefaultButtonID').val());
		if (!btn.is(':disabled')) btn.addClass('btn-main');
	}

	if (typeof $('[data-toggle="tooltip"]').tooltip === 'function') {
		$('[data-toggle="tooltip"]').tooltip();
	}

	$('input[data-toggle="toggle"]').each(function () {
		if (!$(this).parent().hasClass('toggle')) {
			$(this).bootstrapToggle();
		}
	});

	// fix broken modals from postbacks
	setTimeout(function () {
		if ($('.modal.in').length) {
			if (!$('body').hasClass('modal-open')) {
				$('.modal').modal('toggle').modal('toggle');
			}
			else if ($('.modal-backdrop').length === 0) {
				$('body').append($('<DIV/>').addClass('modal-backdrop fade in modal-stack').css('z-index', 1048));
			}
		}
	}, 500);

	focusPageElement();
}

function editTextBankGroup(group, key, page, returnUrl) {
	var url = selerix.applicationRoot + 'textbank.aspx?return=true&insideDialog=true&TextBankGroup=' + encodeURIComponent(group) + '&textBankKey=' + encodeURIComponent(key);
	var reload = true;
	if (page) url += '&AllPageKeys=1';
	if (returnUrl === false) reload = false;
	if (returnUrl !== void 0) url += '&ReturnURL=' + encodeURIComponent(returnUrl);
	var height = $(window).height() - 240;
	var dialogOptions = {
		title: 'Edit Textbank',
		size: 'large',
		showIcon: false,
		keyboard: false,
		keepAfterPostback: true,
		message: '<iframe src="' + url + '" style="width: 100%; height: ' + height + 'px; border: none;" scrolling="no"></iframe>',
		onShown: function (e) {
			selerix.globals.textbankCloseButton = $('#' + $('#gDefaultButtonID').val());
		},
		onHide: function (e) {
			if (!selerix.globals.textbankAllowClose) {
				e.preventDefault();
				e.stopImmediatePropagation();
				return false;
			}
		},
		onHidden: function (e) {
			if (returnUrl)
				location = returnUrl;
			else if (reload && typeof selerix.globals.textBankAutoPost === 'function')
				selerix.globals.textBankAutoPost();
			else if (reload)
				location.reload(true);
		},
		buttons: [{ text: 'Close', defaultButton: true }]
	};

	unlockTextbankDialog()
	selerix.globals.textbankDialog = createDialog(dialogOptions);
}

function closeTextbankDialog() {
	unlockTextbankDialog();
	selerix.globals.textbankDialog.modal('hide');
}

function lockTextbankDialog() {
	if (selerix.globals.textbankCloseButton)
		selerix.globals.textbankCloseButton.prop('disabled', true);

	selerix.globals.textbankAllowClose = false;
}

function unlockTextbankDialog() {
	if (selerix.globals.textbankCloseButton)
		selerix.globals.textbankCloseButton.prop('disabled', false);

	selerix.globals.textbankAllowClose = true;
}

// ---------------------------------------------------------
// Initialize short codes, forms elements like menu and so on
// ---------------------------------------------------------
function initializeFormPage() {
	// ---------------------------------------------------------
	// Toggle
	// ---------------------------------------------------------
	$(".themeblvd-toggle").each(function () {
		$(this).children(".trigger").click(function () {
			$(this).toggleClass("active").next().stop(true, true).slideToggle({
				duration: 'slow',
				complete: function () {
					$(".chartMap").each(function () {
						if (this.locationMap) {
							this.locationMap.ReDraw();
						}
					});

					// Charts could be drawn correctly only when the target 
					// DIV is visible and has non-zero width and height 
					// according to jQWidgets team comments
					if ($(this).is(':visible')) {
						var $thisSlider = $(this);
						$(selerix.globals.charts).each(function (key, chart) {
							// readraw only charts inside this slide
							if ($thisSlider.find('#' + chart.chartID).length > 0) {
								createChart(chart.chartID, chart.width, chart.height, chart.data, chart.showLegend, chart.chartType);
							}
						});
					}
				}
			});
			return false;
		});
	});
}

function checkMinRowsCount(sender, minRows, rowCount) {
	if (minRows != "undefined" && rowCount != "undefined" && minRows != "0" && rowCount <= minRows) {
		alert("You must have at least " + minRows + " rows");
		return false;
	}
	return true;
}

function checkMaxRowsCount(sender, maxRows, rowCount) {
	if (maxRows != "undefined" && rowCount != "undefined" && maxRows != "0" && rowCount >= maxRows) {
		alert("You can not add more than " + maxRows + " rows");
		return false;
	}
	return true;
}

function hideWarningAndKeepAlive() {
	$('.upload-file').each(function () { $(this).hide(); });
	$('#FileUploadCoverDiv').hide();
}

$(function () {
	if ($('.design-mode').length > 0) { require([selerix.applicationRoot + 'selerix_common/js/content-designer.js']); }
});

function createSmartEditors(container) {
	container.find('.smartCurrencyEditor').each(function () { CreateEditor($(this), 'smartCurrencyEditor'); });
	container.find('.smartPercentEditor').each(function () { CreateEditor($(this), 'smartPercentEditor'); });
	container.find('.smartNumericEditor').each(function () { CreateEditor($(this), 'smartNumericEditor'); });
	container.find('.smartTimeEditor').each(function () { CreateEditor($(this), 'smartTimeEditor'); });
	container.find('.smartDatePicker').each(function () { CreateEditor($(this), 'smartDatePicker'); });
	container.find('.smartDateEditor').each(function () { CreateEditor($(this), 'smartDateEditor'); });
	container.find('.smartAutoComplete').each(function () { CreateEditor($(this), 'smartAutoComplete'); });

	container.find('.smartTextEditor').each(function () {
		switch ($(this).attr('data-textMode')) {
			case 'password':
				CreateEditor($(this), 'smartPasswordEditor');
				break;

			case 'multiline':
				CreateEditor($(this), 'smartMultilineEditor');
				break;

			default:
				CreateEditor($(this), 'smartTextEditor');
				break;
		}
	});
}

function SmartCheckBoxList_Init(clientId) {
	var containerId = '#_' + clientId + '_Modal';
	var container = $(containerId);
	var originalCheckboxList = $('#' + clientId).find('input');
	var originalValueList = [];
	var obj = $('#' + clientId);

	for (var i = 0; i < originalCheckboxList.length; i++) {
		var f = obj.find('label[for="' + originalCheckboxList[i].id + '"]');
		originalValueList.push(
			{
				id: originalCheckboxList[i].id,
				value: f[0].innerHTML,
			});
	}

	for (var j = 0; j < originalCheckboxList.length; j++) {
		originalCheckboxList[j].addEventListener('change', function (event) {
			SmartCheckBoxList_HandleCheckboxChange(event, originalCheckboxList);
		});
	}

	var selectText = container.attr('data-editSelection');
	var showSelectNoneButton = container.attr("data-showSelectNoneButton");
	var showSelectAllButton = container.attr("data-showSelectAllButton");
	var isSearchable = container.data("searchable");

	var footer = container.find('.modal-footer');

	var ok = $('<BUTTON/>').attr('type', 'button').addClass("btn btn-main").text('OK').click(function () {
		SmartCheckBoxList_ReturnCheckBoxList(clientId, originalCheckboxList, originalValueList);
		if (isSearchable) {
			smartcheckboxlist_clearInput(clientId, originalCheckboxList);
		}
	});
	footer.append(ok);
	if (showSelectNoneButton == 'true') footer.append($('<BUTTON/>').attr('type', 'button').addClass('btn btn-default').click(function () { SmartCheckBoxList_SelectNone($(this), originalCheckboxList); }).text('Select None'));
	if (showSelectAllButton == 'true') footer.append($('<BUTTON/>').attr('type', 'button').addClass('btn btn-default').click(function () { SmartCheckBoxList_SelectAll($(this), originalCheckboxList); }).text('Select All'));

	if (isSearchable) {
		var searchButton = $('#' + clientId + '_SearchButton');
		searchButton.click(function () {
			SmartCheckBoxList_FilterCheckboxList(clientId, originalCheckboxList);
		});

		var searchInput = document.getElementById(clientId + '_SearchInput');
		var searchInProgress = false;
		searchInput.addEventListener('keyup', function (e) {
			if (searchInProgress) {
				return; // Return early if a search is already in progress
			}
			searchInProgress = true;
			setTimeout(function () {
				SmartCheckBoxList_FilterCheckboxList(clientId, originalCheckboxList);
				searchInProgress = false;
			}, 500);
		});

		var filterAllOption = $('#' + clientId + '_filter_All');
		filterAllOption.click(function () {
			SmartCheckBoxList_SetSelectedOption(clientId, filterAllOption[0].innerText, originalCheckboxList);
		});
		var filterSelectedOption = $('#' + clientId + '_filter_Selected');
		filterSelectedOption.click(function () {
			SmartCheckBoxList_SetSelectedOption(clientId, filterSelectedOption[0].innerText, originalCheckboxList);
		});
	}

	createDialog({ customID: containerId.substring(1) });

	var smartList = $('<div class="panel panel-control pre-scrollable"></div>');
	var smartListBody = $('<div class="panel-body" />');
	smartList.append(smartListBody);

	if (container.data('enabled')) {
		var addButton = $('<button type="button" data-toggle="modal" data-target="' + containerId + '" class="btn btn-sm btn-primary">' + selectText + '</button>');
		addButton.prop('disabled', !container.data('enabled'));
		addButton.appendTo(smartListBody);
	}

	var labelClasses = ('nav nav-pills nav-stacked' + (container.data('enabled') ? ' gutter-top' : ''));
	var selectionLabel = $('<ul id="_' + clientId + '_SelectedItems" class="' + labelClasses + '"></ul>');
	selectionLabel.appendTo(smartListBody);
	container.after(smartList);

	SmartCheckBoxList_UpdateSelections(clientId, originalCheckboxList, originalValueList);
}

function smartcheckboxlist_clearInput(clientId, originalCheckboxList) {
	var modalId = '#_' + clientId + '_Modal';
	var searchInput = document.getElementById(clientId + '_SearchInput');
	searchInput.value = '';
	searchInput.focus();

	// Remove event listeners related to filtering and searching
	$(modalId).off('hide.bs.modal').off('show.bs.modal').off('shown.bs.modal');

	// Add event listener for filtering when the modal is shown
	$(modalId).on('shown.bs.modal', function () {
		SmartCheckBoxList_FilterCheckboxList(clientId, originalCheckboxList);
	}).on('hide.bs.modal', function () {
		searchInput.value = '';
	});
}

function SmartCheckBoxList_HandleCheckboxChange(event, originalCheckboxList) {
	var checkbox = event.target;
	if (checkbox === void 0) return;

	for (var i = 0; i < originalCheckboxList.length; i++) {
		if (originalCheckboxList[i].value === checkbox.value) {
			if (originalCheckboxList[i].type === 'checkbox') {
				originalCheckboxList[i].checked = checkbox.checked;
			}
			break;
		}
	}
}

function SmartCheckBoxList_SetSelectedOption(clientId, option, originalCheckboxList) {
	document.getElementById(clientId + '_SelectFilterButton').innerText = option;
	SmartCheckBoxList_FilterCheckboxList(clientId, originalCheckboxList);
}

function SmartCheckBoxList_FilterCheckboxList(clientId, originalCheckboxList) {
	var searchVal = document.getElementById(clientId + '_SearchInput').value.toLowerCase();
	var filterOption = document.getElementById(clientId + '_SelectFilterButton').innerText;

	var containerId = '#_' + clientId + '_Modal';
	var container = $(containerId);
	var searchUrl = container.attr("data-searchUrl");
	var repeatColumns = parseInt(container.attr("data-repeatColumns")) || 2;
	var repeatDirection = container.attr("data-repeatDirection") || 'Vertical';

	var obj = $('#' + clientId);
	var checkboxTable = obj[0];

	var filteredItem = originalCheckboxList;

	ShowBusyBox();
	ajaxJson('POST', selerix.applicationRoot + searchUrl, JSON.stringify({ queryString: searchVal || '' }), function (data) {
		if (data) {
			if (Array.isArray(data) && data.length > 0) {
				filteredItem = data;
				if (filteredItem.length > 0) {
					obj.empty();
					obj.show();

					var lbl;
					var input;
					var cell;
					var item;

					// Repeat Direction Horizontal
					if (repeatDirection === 'Horizontal') {
						for (var i = 0; i < filteredItem.length; i++) {
							item = $.grep(originalCheckboxList, function (e) { return e.value === filteredItem[i].Value; });
							if (item.length > 0) {
								filteredItem[i].Selected = item[0].checked || item[0].Selected;
								if ((filterOption === 'Selected' && filteredItem[i].Selected) || filterOption === 'All') {
									var newRow;
									if (i % repeatColumns === 0) {
										newRow = checkboxTable.insertRow();
									}

									cell = newRow.insertCell();
									input = $('<INPUT/>').prop({ id: item[0].id, type: 'checkbox', name: item[0].name, value: filteredItem[i].Value, checked: filteredItem[i].Selected });
									$(cell).append(input);
									lbl = $('<LABEL/>').prop('for', item[0].id).html(filteredItem[i].Text);
									$(cell).append(lbl);
								}
							}
						}
					} else {
						// Repeat Direction Vertical
						var repeatRows = filteredItem.length / repeatColumns;
						var row = 0;
						var isNewRow = true;

						for (var i = 0; i < filteredItem.length; i++) {
							if (row >= repeatRows) {
								isNewRow = false;
								row = 0;
							}
							item = $.grep(originalCheckboxList, function (e) { return e.value === filteredItem[i].Value; });
							if (item.length > 0) {
								filteredItem[i].Selected = item[0].checked || item[0].Selected;
								if ((filterOption === 'Selected' && filteredItem[i].Selected) || filterOption === 'All') {
									var newRow;
									if (isNewRow) {
										newRow = checkboxTable.insertRow();
									} else {
										newRow = checkboxTable.rows[row];
									}

									cell = newRow.insertCell();
									input = $('<INPUT/>').prop({ id: item[0].id, type: 'checkbox', name: item[0].name, value: filteredItem[i].Value, checked: filteredItem[i].Selected });
									$(cell).append(input);
									lbl = $('<LABEL/>').prop('for', item[0].id).html(filteredItem[i].Text);
									$(cell).append(lbl);

									row++;
								}
							}
						}
					}
					var newItems = $('#' + clientId).find('input');
					for (var c = 0; c < newItems.length; c++) {
						newItems[c].addEventListener('change', function (event) {
							SmartCheckBoxList_HandleCheckboxChange(event, originalCheckboxList);
						});
					}
				}
			}
		}

		HideBusyBox();
	}, function (err) {
		HideBusyBox();
		createDialog({ title: 'Response Error', message: 'There was an error. Please try again.', type: 'alert', state: 'danger' });
	});
}

function SmartCheckBoxList_RenderCheckboxList(clientId, filteredItem, callback) {
	var containerId = '#_' + clientId + '_Modal';
	var container = $(containerId);
	var repeatColumns = parseInt(container.attr("data-repeatColumns")) || 2;
	var repeatDirection = container.attr("data-repeatDirection") || 'Vertical';

	var obj = $('#' + clientId);
	var checkboxTable = obj[0];
	obj.empty();
	obj.hide();

	ShowBusyBox();

	if (filteredItem.length > 0) {
		var cell;

		// Repeat Direction Horizontal
		if (repeatDirection === 'Horizontal') {
			for (var i = 0; i < filteredItem.length; i++) {
				var newRow;
				if (i % repeatColumns === 0) {
					newRow = checkboxTable.insertRow();
				}

				cell = newRow.insertCell();
				insertInput(cell, filteredItem[i]);
			}
		} else {
			// Repeat Direction Vertical
			var repeatRows = filteredItem.length / repeatColumns;
			var row = 0;
			var isNewRow = true;
			for (var i = 0; i < filteredItem.length; i++) {
				if (row >= repeatRows) {
					isNewRow = false;
					row = 0;
				}
				var newRow;
				if (isNewRow) {
					newRow = checkboxTable.insertRow();
				} else {
					newRow = checkboxTable.rows[row];
				}

				cell = newRow.insertCell();
				insertInput(cell, filteredItem[i]);
				row++;
			}
		}
	}
	HideBusyBox();

	if (callback && typeof callback === 'function') {
		callback();
	}
}

function insertInput(cell, filteredItem) {
	var input = $('<INPUT/>').prop({ id: filteredItem.id, type: 'checkbox', name: filteredItem.name, value: filteredItem.value, checked: true });
	$(cell).append(input);

	var lbl = $('<LABEL/>').prop('for', filteredItem.id).html(filteredItem.text);
	$(cell).append(lbl);
}

function getSelectedItems(originalCheckboxList) {
	var selectedItems = [];

	for (var i = 0; i < originalCheckboxList.length; i++) {
		if (originalCheckboxList[i].checked || originalCheckboxList[i].Selected) {
			selectedItems.push({
				id: originalCheckboxList[i].id,
				value: originalCheckboxList[i].value,
				text: $('#' + originalCheckboxList[i].id).next('label').text(),
				name: originalCheckboxList[i].name
			});
		}
	}

	return selectedItems;
}

function SmartCheckBoxList_ReturnCheckBoxList(clientId, originalCheckboxList, originalValueList) {
	SmartCheckBoxList_UpdateSelections(clientId, originalCheckboxList, originalValueList);
	var modalId = '#_' + clientId + '_Modal';

	var selectedItems = getSelectedItems(originalCheckboxList);

	SmartCheckBoxList_RenderCheckboxList(clientId, selectedItems, function () {
		$(modalId).modal('hide');
	});
}

function SmartCheckBoxList_UpdateSelections(clientId, originalCheckboxList, originalValueList) {
	var containerId = '#_' + clientId + '_Modal';
	var container = $(containerId);

	var list = new Array();

	for (var i = 0; i < originalCheckboxList.length; i++) {
		if (originalCheckboxList[i].checked || originalCheckboxList[i].Selected) {
			var f = $.grep(originalValueList, function (e) { return e.id === originalCheckboxList[i].id; });
			list.push(f[0].value);
		}
	}

	if (list.length == 0) list.push(container.attr('data-noSelection'));
	var selection = $('#_' + clientId + '_SelectedItems');
	selection.html('<li>' + list.join('</li><li>') + '</li>');
}

function SmartCheckBoxList_SelectAll(obj, originalCheckboxList) {
	var selectedItems = obj.closest('.modal-content').find('input');
	for (var i = 0; i < selectedItems.length; i++) {
		selectedItems[i].checked = true;
	}

	for (var i = 0; i < originalCheckboxList.length; i++) {
		originalCheckboxList[i].checked = true;
	}
}

function SmartCheckBoxList_SelectNone(obj, originalCheckboxList) {
	var selectedItems = obj.closest('.modal-content').find('input');
	for (var i = 0; i < selectedItems.length; i++) {
		selectedItems[i].checked = false;
	}

	for (var i = 0; i < originalCheckboxList.length; i++) {
		originalCheckboxList[i].checked = false;
	}
}

function MakeQRCode(element, qrCodeOptions) {
	require(['qrcode'], function (QRCodeModule) {
		qrCodeOptions = typeof qrCodeOptions === 'string' ? { text: qrCodeOptions } : qrCodeOptions;
		qrCodeOptions.colorDark = qrCodeOptions.colorDark || '#000000';
		qrCodeOptions.colorLight = qrCodeOptions.colorLight || '#ffffff';
		qrCodeOptions.correctLevel = qrCodeOptions.correctLevel || QRCode.CorrectLevel.L;

		element = typeof element === 'string' ? document.getElementById(element) : element;

		new QRCodeModule(element, qrCodeOptions);
	});
}

var bypassMailtoBusyBoxes = function (container) {
	// bypass busybox for mailto links
	container = container || '';
	$(container + ' a[href^="mailto:"]:not([onclick])').each(function () {
		$(this).off('click.mailto').on('click.mailto', function () { Page_BusyBox.Bypass(); });
	});
};

$(function () {
	bypassMailtoBusyBoxes();
	if (typeof (Sys) != 'undefined') {
		Sys.WebForms.PageRequestManager.getInstance().add_endRequest(function () { bypassMailtoBusyBoxes() });
		if (!RequestHandlerSet) {
			Sys.WebForms.PageRequestManager.getInstance().add_beginRequest(BeginRequestHandler);
			Sys.WebForms.PageRequestManager.getInstance().add_endRequest(EndRequestHandler);
			RequestHandlerSet = true;
		}
	}
});

function disableAutocomplete() {
	//$(document).ready(function () {
	//	$('input[autocomplete="off"]:not([disabled]):not(.jqx-combobox-input)').attr('autocomplete', 'nope').prop('disabled', true);
	//	setTimeout(function () {
	//		$('input[autocomplete="nope"]').prop('disabled', false);
	//	}, 2000);
	//});
}